/* KE Reviews bundel adaf409 — gegenereerd door scripts/bundel.py */
if (!window.__keBundel) {
window.__keBundel = "adaf409";
var __KE_C = {};
[].forEach.call(document.querySelectorAll('script.ke-cfg'), function (s) {
  try { __KE_C[s.getAttribute('data-blok')] = JSON.parse(s.textContent || '{}'); }
  catch (e) { __KE_C[s.getAttribute('data-blok')] = {}; console.error('KE Reviews cfg', e); }
});
/* basis (review.css) */
if (__KE_C["basis"]) try {
window.KE_I18N = {
nl:{by:"door",kecust:"een Kamera Express-klant",replyFrom:"Antwoord van Kamera Express",seeReply:"Bekijk antwoord",hideReply:"Verberg antwoord",photo:"Foto bekijken",verifiedBuyer:"Geverifieerde koper",verifiedReviewer:"Geverifieerde reviewer",title:"Beoordelingen",subSvc:"Beoordelingen over onze service en winkel",subPrd:"Beoordelingen over dit product",tabPrd:"Product",tabSvc:"Service & winkel",all:"Alle",loading:"Reviews laden\u2026",none:"Geen reviews met deze filter.",nonePrd:"Nog geen productreviews.",error:"Kon reviews niet laden.",verified:"Geverifieerd",powered:"Mogelijk gemaakt door",reviews:"beoordelingen",uspWith:"volgens",uspPlain:"gemiddelde beoordeling",translate:"Vertalen",showOriginal:"Toon origineel",translatedFrom:"Vertaald uit het",translating:"Vertalen\u2026",translateFailed:"Vertaling niet beschikbaar",about:"Over",write:"Schrijf een review",more:"Meer reviews tonen",sortBy:"Sorteren op",sortRecent:"Nieuwste eerst",sortHelpful:"Populairst",metFoto:"Met foto's",sortHigh:"Hoog naar laag",sortLow:"Laag naar hoog",helpful:"Was dit nuttig?",helpfulYes:"Ja, nuttig",helpfulNo:"Niet nuttig",helpfulUndo:"Stem intrekken",tabUsed:"Tweedehands gekocht",tabNew:"Nieuw gekocht",tabAll:"Alle ervaringen",boughtUsed:"Tweedehands gekocht",boughtNew:"Nieuw gekocht",lab:{e:"Uitstekend",vg:"Zeer goed",g:"Goed",f:"Redelijk",p:"Matig"}},
en:{by:"by",kecust:"a Kamera Express customer",replyFrom:"Reply from Kamera Express",seeReply:"See reply",hideReply:"Hide reply",photo:"View photo",verifiedBuyer:"Verified buyer",verifiedReviewer:"Verified reviewer",title:"Reviews",subSvc:"Reviews about our service and store",subPrd:"Reviews about this product",tabPrd:"Product",tabSvc:"Service & store",all:"All",loading:"Loading reviews\u2026",none:"No reviews with this filter.",nonePrd:"No product reviews yet.",error:"Could not load reviews.",verified:"Verified",powered:"Powered by",reviews:"reviews",uspWith:"based on",uspPlain:"average rating",translate:"Translate",showOriginal:"Show original",translatedFrom:"Translated from",translating:"Translating\u2026",translateFailed:"Translation unavailable",about:"About",write:"Write a review",more:"Show more reviews",sortBy:"Sort by",sortRecent:"Most recent",sortHelpful:"Most liked",metFoto:"With photos",sortHigh:"High to low",sortLow:"Low to high",helpful:"Was this helpful?",helpfulYes:"Yes, helpful",helpfulNo:"Not helpful",helpfulUndo:"Undo vote",tabUsed:"Bought second-hand",tabNew:"Bought new",tabAll:"All experiences",boughtUsed:"Bought second-hand",boughtNew:"Bought new",lab:{e:"Excellent",vg:"Very Good",g:"Good",f:"Fair",p:"Poor"}},
fr:{by:"par",kecust:"un client Kamera Express",replyFrom:"R\u00e9ponse de Kamera Express",seeReply:"Voir la r\u00e9ponse",hideReply:"Masquer la r\u00e9ponse",photo:"Voir la photo",verifiedBuyer:"Acheteur v\u00e9rifi\u00e9",verifiedReviewer:"\u00c9valuateur v\u00e9rifi\u00e9",title:"Avis",subSvc:"Avis sur notre service et notre boutique",subPrd:"Avis sur ce produit",tabPrd:"Produit",tabSvc:"Service & boutique",all:"Tous",loading:"Chargement des avis\u2026",none:"Aucun avis avec ce filtre.",nonePrd:"Pas encore d'avis produit.",error:"Impossible de charger les avis.",verified:"V\u00e9rifi\u00e9",powered:"Propuls\u00e9 par",reviews:"avis",uspWith:"selon",uspPlain:"note moyenne",translate:"Traduire",showOriginal:"Voir l'original",translatedFrom:"Traduit du",translating:"Traduction\u2026",translateFailed:"Traduction indisponible",about:"Sur",write:"\u00c9crire un avis",more:"Afficher plus d'avis",sortBy:"Trier par",sortRecent:"Plus r\u00e9cents",sortHelpful:"Les plus appr\u00e9ci\u00e9s",metFoto:"Avec photos",sortHigh:"Du plus haut au plus bas",sortLow:"Du plus bas au plus haut",helpful:"Cet avis vous a-t-il aid\u00e9\u00a0?",helpfulYes:"Oui, utile",helpfulNo:"Pas utile",helpfulUndo:"Retirer le vote",tabUsed:"Achet\u00e9 d'occasion",tabNew:"Achet\u00e9 neuf",tabAll:"Tous les avis",boughtUsed:"Achet\u00e9 d'occasion",boughtNew:"Achet\u00e9 neuf",lab:{e:"Excellent",vg:"Tr\u00e8s bon",g:"Bon",f:"Satisfaisant",p:"Insuffisant"}},
de:{by:"von",kecust:"einem Kamera Express-Kunden",replyFrom:"Antwort von Kamera Express",seeReply:"Antwort ansehen",hideReply:"Antwort ausblenden",photo:"Foto ansehen",verifiedBuyer:"Verifizierter K\u00e4ufer",verifiedReviewer:"Verifizierter Rezensent",title:"Bewertungen",subSvc:"Bewertungen \u00fcber unseren Service und Shop",subPrd:"Bewertungen zu diesem Produkt",tabPrd:"Produkt",tabSvc:"Service & Shop",all:"Alle",loading:"Bewertungen werden geladen\u2026",none:"Keine Bewertungen mit diesem Filter.",nonePrd:"Noch keine Produktbewertungen.",error:"Bewertungen konnten nicht geladen werden.",verified:"Verifiziert",powered:"Bereitgestellt von",reviews:"Bewertungen",uspWith:"laut",uspPlain:"Durchschnittsbewertung",translate:"\u00dcbersetzen",showOriginal:"Original anzeigen",translatedFrom:"\u00dcbersetzt aus dem",translating:"\u00dcbersetzung\u2026",translateFailed:"\u00dcbersetzung nicht verf\u00fcgbar",about:"\u00dcber",write:"Bewertung schreiben",more:"Mehr Bewertungen anzeigen",sortBy:"Sortieren nach",sortRecent:"Neueste",sortHelpful:"Beliebteste",metFoto:"Mit Fotos",sortHigh:"Beste Bewertung",sortLow:"Schlechteste Bewertung",helpful:"War das hilfreich?",helpfulYes:"Ja, hilfreich",helpfulNo:"Nicht hilfreich",helpfulUndo:"Bewertung zur\u00fccknehmen",tabUsed:"Gebraucht gekauft",tabNew:"Neu gekauft",tabAll:"Alle Erfahrungen",boughtUsed:"Gebraucht gekauft",boughtNew:"Neu gekauft",lab:{e:"Ausgezeichnet",vg:"Sehr gut",g:"Gut",f:"Befriedigend",p:"Mäßig"}},
es:{by:"por",kecust:"un cliente de Kamera Express",replyFrom:"Respuesta de Kamera Express",seeReply:"Ver respuesta",hideReply:"Ocultar respuesta",photo:"Ver foto",verifiedBuyer:"Comprador verificado",verifiedReviewer:"Rese\u00f1ador verificado",title:"Rese\u00f1as",subSvc:"Rese\u00f1as sobre nuestro servicio y tienda",subPrd:"Rese\u00f1as sobre este producto",tabPrd:"Producto",tabSvc:"Servicio y tienda",all:"Todas",loading:"Cargando rese\u00f1as\u2026",none:"No hay rese\u00f1as con este filtro.",nonePrd:"A\u00fan no hay rese\u00f1as del producto.",error:"No se pudieron cargar las rese\u00f1as.",verified:"Verificado",powered:"Con la tecnolog\u00eda de",reviews:"rese\u00f1as",uspWith:"seg\u00fan",uspPlain:"valoraci\u00f3n media",translate:"Traducir",showOriginal:"Ver original",translatedFrom:"Traducido del",translating:"Traduciendo\u2026",translateFailed:"Traducci\u00f3n no disponible",about:"Sobre",write:"Escribir una rese\u00f1a",more:"Mostrar m\u00e1s rese\u00f1as",sortBy:"Ordenar por",sortRecent:"M\u00e1s recientes",sortHelpful:"M\u00e1s populares",metFoto:"Con fotos",sortHigh:"De mayor a menor",sortLow:"De menor a mayor",helpful:"\u00bfTe result\u00f3 \u00fatil?",helpfulYes:"S\u00ed, \u00fatil",helpfulNo:"No \u00fatil",helpfulUndo:"Retirar voto",tabUsed:"Comprado de segunda mano",tabNew:"Comprado nuevo",tabAll:"Todas las experiencias",boughtUsed:"Comprado de segunda mano",boughtNew:"Comprado nuevo",lab:{e:"Excelente",vg:"Muy bueno",g:"Bueno",f:"Aceptable",p:"Regular"}},
it:{by:"di",kecust:"un cliente Kamera Express",replyFrom:"Risposta di Kamera Express",seeReply:"Vedi risposta",hideReply:"Nascondi risposta",photo:"Vedi foto",verifiedBuyer:"Acquirente verificato",verifiedReviewer:"Recensore verificato",title:"Recensioni",subSvc:"Recensioni sul nostro servizio e negozio",subPrd:"Recensioni su questo prodotto",tabPrd:"Prodotto",tabSvc:"Servizio e negozio",all:"Tutte",loading:"Caricamento recensioni\u2026",none:"Nessuna recensione con questo filtro.",nonePrd:"Ancora nessuna recensione del prodotto.",error:"Impossibile caricare le recensioni.",verified:"Verificato",powered:"Con tecnologia",reviews:"recensioni",uspWith:"secondo",uspPlain:"valutazione media",translate:"Traduci",showOriginal:"Mostra originale",translatedFrom:"Tradotto dal",translating:"Traduzione\u2026",translateFailed:"Traduzione non disponibile",about:"Su",write:"Scrivi una recensione",more:"Mostra altre recensioni",sortBy:"Ordina per",sortRecent:"Pi\u00f9 recenti",sortHelpful:"Pi\u00f9 apprezzate",metFoto:"Con foto",sortHigh:"Dal pi\u00f9 alto al pi\u00f9 basso",sortLow:"Dal pi\u00f9 basso al pi\u00f9 alto",helpful:"\u00c8 stata utile?",helpfulYes:"S\u00ec, utile",helpfulNo:"Non utile",helpfulUndo:"Annulla voto",tabUsed:"Acquistato usato",tabNew:"Acquistato nuovo",tabAll:"Tutte le esperienze",boughtUsed:"Acquistato usato",boughtNew:"Acquistato nuovo",lab:{e:"Eccellente",vg:"Molto buono",g:"Buono",f:"Discreto",p:"Mediocre"}}
};
window.KE_H = (function(){

function esc(str){return String(str==null?'':str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');}

function stars(rating,cls){
var p=Math.max(0,Math.min(100,((rating||0)/5)*100));
return '<span class="'+(cls||'ke-rev-stars')+' ke-st"><span class="ke-st-bg" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</span><span class="ke-st-fg" style="width:'+p.toFixed(1)+'%">\u2605\u2605\u2605\u2605\u2605</span></span>';
}
function timeAgo(iso,lang){if(!iso)return '';var d=new Date(iso);if(isNaN(d.getTime()))return '';var diff=Math.round((d.getTime()-Date.now())/1000);var rtf;try{rtf=new Intl.RelativeTimeFormat(lang,{numeric:'auto'});}catch(e){rtf=new Intl.RelativeTimeFormat('en',{numeric:'auto'});}var a=Math.abs(diff);if(a<3600)return rtf.format(Math.round(diff/60),'minute');if(a<86400)return rtf.format(Math.round(diff/3600),'hour');if(a<2592000)return rtf.format(Math.round(diff/86400),'day');if(a<31536000)return rtf.format(Math.round(diff/2592000),'month');return rtf.format(Math.round(diff/31536000),'year');}
function langName(code){try{return new Intl.DisplayNames(['en'],{type:'language'}).of(code);}catch(e){return (code||'').toUpperCase();}}
function fmtScore(n,lang){var r=Math.round(n*100)/100;if(Math.abs(r-Math.round(r))<0.005)return Math.round(r).toLocaleString(lang);

return r.toLocaleString(lang,{maximumFractionDigits:2});}
function srcMark(source){
if(source==='ts') return '<span class="ke-rev-src ke-rev-src-ts" title="Trusted Shops">e</span>';
return '<span class="ke-rev-src ke-rev-src-ke" title="Kamera Express">K</span>';
}

var TW={en:'the and was very with this for that have not are my',de:'und der die das ist nicht mit sehr ich wurde auch wir ein eine was',
nl:'het een niet ik met zeer goed snel werd ook maar van was',fr:'les et très pas est une je livraison des pour',
es:'muy que con los las para pero también',it:'molto che con di non sono anche per della'};
var TWS={}; for (var k in TW) TWS[k]=(' '+TW[k]+' ');
function taal(txt){
var w=String(txt||'').toLowerCase().replace(/[^a-zà-ÿ\s]/g,' ').split(/\s+/), sc={}, best=null, hi=0, gelijk=false;
for (var i=0;i<w.length;i++){ if(!w[i]) continue; for (var l in TWS){ if(TWS[l].indexOf(' '+w[i]+' ')!==-1) sc[l]=(sc[l]||0)+1; } }
for (var l2 in sc){ if(sc[l2]>hi){ hi=sc[l2]; best=l2; gelijk=false; } else if(sc[l2]===hi) gelijk=true; }
return hi>=2 && !gelijk ? best : null;
}
return { esc:esc, stars:stars, timeAgo:timeAgo, langName:langName, fmtScore:fmtScore, srcMark:srcMark, taal:taal };
})();
} catch (e) { console.error('KE Reviews basis:', e); }
/* uitbreiding (6-uitbreiding.liquid) */
if (__KE_C["uitbreiding"]) try {
(function(){
var H = window.KE_H;
if (!H) { console.warn('KE Reviews: blok 6 hoort ONDER blok 0 en BOVEN blok 1 — hooks niet geladen.'); return; }

var STAR = '<svg aria-hidden="true"><use href="#ke-star"></use></svg>';
var STAR_F = STAR.replace('<svg', '<svg class="ke-sv-f"');

function ster(pct){ return '<span style="--f:' + pct + '%">' + STAR + STAR_F + '</span>'; }

function sterren(rating, cls){
var r = Math.max(0, Math.min(5, Number(rating) || 0)), out = '';
for (var i = 0; i < 5; i++) out += ster(Math.round(Math.max(0, Math.min(1, r - i)) * 100));
return '<span class="' + (cls || 'ke-rev-stars') + ' ke-sv" role="img" aria-label="' +
(Math.round(r * 100) / 100) + ' / 5">' + out + '</span>';
}
H.stars = sterren;

window.KE_SEC_T = {
METRIC: {
nl:{"Ease of use":"Gebruiksgemak","Quality":"Kwaliteit","Design":"Design","Robustness":"Robuustheid","Available options":"Beschikbare opties"},
de:{"Ease of use":"Bedienung","Quality":"Qualität","Design":"Design","Robustness":"Robustheit","Available options":"Verfügbare Optionen"},
fr:{"Ease of use":"Facilité d’utilisation","Quality":"Qualité","Design":"Design","Robustness":"Robustesse","Available options":"Options disponibles"},
es:{"Ease of use":"Facilidad de uso","Quality":"Calidad","Design":"Diseño","Robustness":"Robustez","Available options":"Opciones disponibles"},
it:{"Ease of use":"Facilità d’uso","Quality":"Qualità","Design":"Design","Robustness":"Robustezza","Available options":"Opzioni disponibili"}
}
};

window.KE_X = {

naSort: function(items, filter, sort, stemmenVan){
if (sort === 'helpful') {
items = items.slice().sort(function(a, b){
var va = stemmenVan(a), vb = stemmenVan(b);
return (vb.u - vb.d) - (va.u - va.d)
|| String(b.date).localeCompare(String(a.date));
});
}
if (filter !== 'all') return items;
var hoog = [], laag = [];
items.forEach(function(r){ (Math.round(r.rating) >= 4 ? hoog : laag).push(r); });
return hoog.concat(laag);
},

tellen: function(items, filtersEl, t, lang, tab){
var svc = tab === 'service';
var n = [0, 0, 0, 0, 0, 0];
items.forEach(function(r){ var k = Math.round(r.rating); if (k >= 1 && k <= 5) n[k]++; });
filtersEl.querySelectorAll('.ke-rev-pill[data-filter]').forEach(function(p){
var f = p.getAttribute('data-filter');
var c = f === 'all' ? items.length : (n[Number(f)] || 0);
var label = f === 'all' ? H.esc(t.all) : f + '<span class="ke-sv">' + ster(100) + '</span>';
p.innerHTML = label;
p.disabled = (!svc && c === 0 && f !== 'all');
});
},
sterren: sterren
};
})();
} catch (e) { console.error('KE Reviews uitbreiding:', e); }
/* pdp (1Customreview_slideout.liquid) */
if (__KE_C["pdp"]) try {
(function () {
var PROXY_BASE = "https://ke-reviews-proxy.marketing-bff.workers.dev/";
var TRIGGER_ID = "reviews";
var BAR_ROTATE_MS = 8000;

var KE_LOGO = String(__KE_C["pdp"].k0 == null ? "" : __KE_C["pdp"].k0);

var COUNTRY = (String(__KE_C["pdp"].k1 == null ? "" : __KE_C["pdp"].k1) || "NL").toUpperCase();

var LANG = (String(__KE_C["pdp"].k2 == null ? "" : __KE_C["pdp"].k2) || "nl").toLowerCase().split(/[-_]/)[0];

var SKU = String(__KE_C["pdp"].k3 || "");
var YOTPO_ID = String(__KE_C["pdp"].k4 == null ? "" : __KE_C["pdp"].k4);

if (!window.KE_I18N || !window.KE_H) {
console.warn('KE Reviews: blok 0 (CSS + depot) moet BOVEN blok 1 staan — gestopt.');
return;
}
var I18N = window.KE_I18N, H = window.KE_H;
var esc = H.esc, srcMark = H.srcMark, langName = H.langName;

function stars(rating, cls){ return H.stars(rating, cls); }
function timeAgo(iso){ return H.timeAgo(iso, LANG); }

function taalVan(r){ return r.lang || (H.taal && H.taal((r.title||'')+' '+(r.comment||''))) || r.srcLang || ''; }
function fmtScore(n){ return H.fmtScore(n, LANG); }
var X = window.KE_X || {};
var t = I18N[LANG] || I18N.en;
var SERVICE_URL = PROXY_BASE + "?country=" + encodeURIComponent(COUNTRY) + "&lang=" + encodeURIComponent(LANG);

var MO = null, KE_USED = false, KE_MODEL = "";
try {
var moEl = document.getElementById('ke-mo-data');
if (moEl) {
var moData = JSON.parse(moEl.textContent);

KE_USED = !!moData.used; KE_MODEL = moData.model || "";
if (moData && moData.count > 0) {
MO = moData;

var b = MO.bar;
if (b && (b.q || b.split)) { MO.split = b.split || null; MO.naam = b.naam || "";
MO.mv = b.mv || 0; MO.bar = b.q || {}; }
}
}
} catch (e) { MO = null; }

var mijnStemmen = {};
try { mijnStemmen = JSON.parse(localStorage.getItem('ke-rev-votes') || '{}'); } catch (e) {}
function bewaarStemmen(){
try { localStorage.setItem('ke-rev-votes', JSON.stringify(mijnStemmen)); } catch (e) {}
}

function stemToken(){
try {
var tk = localStorage.getItem('ke-rev-voter');
if (!tk){
var a = new Uint8Array(16); (window.crypto || window.msCrypto).getRandomValues(a);
tk = ''; for (var i = 0; i < 16; i++) tk += ('0' + a[i].toString(16)).slice(-2);
localStorage.setItem('ke-rev-voter', tk);
}
return tk;
} catch (e) { return ''; }
}

var stemPot = { product: {}, service: {} };
function stemSleutel(){ return activeTab === 'product' ? SKU : ('svc-' + COUNTRY); }
function stemmenVan(r){
var basisU = r.source === 'yotpo' ? (r.votesUp||0) : 0;
var basisD = r.source === 'yotpo' ? (r.votesDown||0) : 0;
var v = stemPot[activeTab === 'product' ? 'product' : 'service'][r.id] || {};
return { u: Math.max(0, basisU + (v.u||0)), d: Math.max(0, basisD + (v.d||0)) };
}
function thumbIcon(down){
return '<svg class="ke-vote-ico" width="15" height="15" viewBox="0 0 24 24" fill="none"'+
(down ? ' style="transform:rotate(180deg)"' : '')+' aria-hidden="true">'+
'<path d="M7 10v11H4a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h3zm4-8 1 1-1 6h6a2 2 0 0 1 2 2.4l-1.4 7A2 2 0 0 1 15.6 21H7V10l4-8z"'+
' stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
}
function stemUI(r){
var v = stemmenVan(r), mijn = mijnStemmen[r.id];
return '<span class="ke-vote" data-votewrap>'+
'<span class="ke-vote-q">'+esc(t.helpful)+'</span>'+
'<button type="button" class="ke-vote-btn'+(mijn==='up'?' voted':'')+'" data-vote="up" data-id="'+esc(r.id)+
'" aria-pressed="'+(mijn==='up')+'" title="'+esc(mijn==='up'?t.helpfulUndo:t.helpfulYes)+
'" aria-label="'+esc(t.helpfulYes)+'">'+thumbIcon(false)+'<span data-up>'+v.u+'</span></button>'+
'<button type="button" class="ke-vote-btn'+(mijn==='down'?' voted':'')+'" data-vote="down" data-id="'+esc(r.id)+
'" aria-pressed="'+(mijn==='down')+'" title="'+esc(mijn==='down'?t.helpfulUndo:t.helpfulNo)+
'" aria-label="'+esc(t.helpfulNo)+'">'+thumbIcon(true)+'<span data-down>'+v.d+'</span></button>'+
'</span>';
}

function versVotes(sleutel, pot){
fetch(PROXY_BASE + '?action=votes&sku=' + encodeURIComponent(sleutel))
.then(function(r){ return r.json(); })
.then(function(d){
if (!d || !d.votes) return;
for (var k in pot) delete pot[k];
for (var k2 in d.votes) pot[k2] = d.votes[k2];
if (panelOpen) render();
if (window.KEReviewsSection && window.KEReviewsSection.onData) window.KEReviewsSection.onData();
})["catch"](function(){});
}

function stemVerschil(van, naar){
if (van === naar) return null;
var du = (naar==='up'?1:0) - (van==='up'?1:0);
var dd = (naar==='down'?1:0) - (van==='down'?1:0);
return { du: du, dd: dd };
}
function opStem(knop){
var id = knop.getAttribute('data-id');
var richting = knop.getAttribute('data-vote');
var wrap = knop.closest('[data-votewrap]');
var vorige = mijnStemmen[id] || 'none';
var nieuw = vorige === richting ? 'none' : richting;
var v = stemVerschil(vorige, nieuw);
if (!v) return;
var opUp = wrap.querySelector('[data-up]'), opDown = wrap.querySelector('[data-down]');
var wasU = parseInt(opUp.textContent,10)||0, wasD = parseInt(opDown.textContent,10)||0;
function toon(u, d, actief){
opUp.textContent = Math.max(0,u); opDown.textContent = Math.max(0,d);
var kn = wrap.querySelectorAll('.ke-vote-btn');
kn[0].classList.toggle('voted', actief==='up');
kn[1].classList.toggle('voted', actief==='down');
kn[0].setAttribute('aria-pressed', actief==='up');
kn[1].setAttribute('aria-pressed', actief==='down');
}

toon(wasU+v.du, wasD+v.dd, nieuw==='none'?null:nieuw);
if (nieuw === 'none') delete mijnStemmen[id]; else mijnStemmen[id] = nieuw;
bewaarStemmen();

var pot = stemPot[activeTab === 'product' ? 'product' : 'service'];
var lok = pot[id] || (pot[id] = { u:0, d:0 });
lok.u += v.du; lok.d += v.dd;
fetch(PROXY_BASE + '?action=vote&id=' + encodeURIComponent(id) +
'&sku=' + encodeURIComponent(stemSleutel()) +
'&voter=' + encodeURIComponent(stemToken()) +
'&from=' + vorige + '&to=' + nieuw, { method: 'POST' })
.then(function(res){ return res.json(); })
.then(function(d){
if (!d || !d.ok) throw new Error('mislukt');

var stand = d.naar || nieuw;
if (stand === 'none') delete mijnStemmen[id]; else mijnStemmen[id] = stand;
bewaarStemmen();
if (d.votes){
pot[id] = { u: d.votes.u || 0, d: d.votes.d || 0 };
toon(pot[id].u, pot[id].d, stand === 'none' ? null : stand);
}
})
.catch(function(){
toon(wasU, wasD, vorige==='none'?null:vorige);
lok.u -= v.du; lok.d -= v.dd;
if (vorige === 'none') delete mijnStemmen[id]; else mijnStemmen[id] = vorige;
bewaarStemmen();
});
}

var PRODUCT_URL = PROXY_BASE + "?action=product&sku=" + encodeURIComponent(SKU) +
"&yotpo=" + encodeURIComponent(YOTPO_ID) +
"&country=" + encodeURIComponent(COUNTRY) + "&lang=" + encodeURIComponent(LANG);

if (MO) PRODUCT_URL += "&moscore=" + MO.score + "&mocount=" + MO.count;

var USED = KE_USED || !!(MO && MO.mv);
var MODEL_KEY = USED ? (KE_MODEL || (MO && MO.model) || "") : "";
if (MODEL_KEY) PRODUCT_URL += "&model=" + encodeURIComponent(MODEL_KEY);
if (USED) PRODUCT_URL += "&cond=used";
var PRODUCT_FULL_URL = PRODUCT_URL + "&full=1";

var svcPromise = null, prdPromise = null, prdFullPromise = null;

var SVC_LS = 'ke-svc-' + COUNTRY;
function svcVanSchijf(){
try {
var r = JSON.parse(localStorage.getItem(SVC_LS) || 'null');
if (r && r.at && (Date.now() - r.at) < 86400000 && r.d && r.d.items) return r.d;
} catch (e) {}
return null;
}
function svcVers(){
return fetch(SERVICE_URL).then(function(r){return r.json();})
.then(function(d){
if (!d || !d.items) return d;
stemPot.service = d.votes = (d.votes || {});
versVotes('svc-' + COUNTRY, stemPot.service);
try { localStorage.setItem(SVC_LS, JSON.stringify({ at: Date.now(), d: d })); } catch (e) {}
return d;
});
}
function svcData(){
if (svcPromise) return svcPromise;
var oud = svcVanSchijf();
if (oud) {
stemPot.service = oud.votes = (oud.votes || {});
versVotes('svc-' + COUNTRY, stemPot.service);
svcPromise = Promise.resolve(oud);

svcVers().then(function(d){
if (!d || !d.items) return;
svcPromise = Promise.resolve(d);
if (panelOpen && activeTab === 'service') { renderScore(); render(); }
}).catch(function(){});
return svcPromise;
}
svcPromise = svcVers().catch(function(){ return null; });
return svcPromise;
}
function prdData(){
if(!prdPromise) prdPromise = fetch(PRODUCT_URL).then(function(r){return r.json();}).catch(function(){return null;});
return prdPromise;
}

var overlay = document.getElementById('ke-rev-overlay');
var closeBtn = document.getElementById('ke-rev-close');
var body = document.getElementById('ke-rev-body');
body.addEventListener('scroll',function(){body.parentElement.classList.toggle('ke-scrolled',body.scrollTop>8&&matchMedia('(max-width:749px)').matches);},{passive:true});
var panelSort = 'top';
var filters = document.getElementById('ke-rev-filters');
var tabsEl = document.getElementById('ke-rev-tabs');
if (!overlay) return;

if (overlay.parentElement !== document.body) document.body.appendChild(overlay);

document.getElementById('ke-rev-title').textContent = t.title;
document.querySelector('.ke-rev-pill[data-filter="all"]').textContent = t.all;
document.querySelector('.ke-rev-tab[data-tab="product"]').textContent = t.tabPrd;
document.querySelector('.ke-rev-tab[data-tab="service"]').textContent = t.tabSvc;
var sortPil = document.getElementById('ke-rev-sort');
sortPil.textContent = t.sortHelpful;

sortPil.addEventListener('click', function(){ zetFilter(activeFilter === 'helpful' ? 'all' : 'helpful'); render(); });

var mediaPil = document.getElementById('ke-rev-media');
mediaPil.textContent = t.metFoto || 'With photos';
mediaPil.addEventListener('click', function(){ zetFilter(activeFilter === 'media' ? 'all' : 'media'); render(); });
body.innerHTML = '<p class="ke-rev-status">' + t.loading + '</p>';

var svc = { items: [], byId: {}, grade: null, loaded: false, failed: false };
var prd = { items: [], byId: {}, average: null, total: 0, barQuotes: [], metrics: null, loaded: false, failed: false };
var activeTab = 'product', activeFilter = 'all', transCache = {};
var barSlides = [], barIdx = 0, barTimer = null, panelOpen = false, barObserver = null, barVisible = true;
var pollTimer = null;
var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function openPanel(tab){

versVotes(SKU, stemPot.product);
versVotes('svc-' + COUNTRY, stemPot.service);
loadProductFull();
if (tab === 'service') loadService().then(function(){ if(activeTab==='service'){ renderScore(); render(); } });
if (tab) setTab(tab);
panelOpen = true;
suppressBar(true);
overlay.classList.add('open');
overlay.setAttribute('aria-hidden','false');
document.body.style.overflow='hidden';
stopBar();
fotoKijk(body);
}
function closePanel(){
panelOpen = false;
suppressBar(false);
overlay.classList.remove('open');
overlay.setAttribute('aria-hidden','true');
document.body.style.overflow='';
startBar();
}
function setTab(tab){
activeTab = tab; activeFilter = 'all';

if (tab === 'service' && !svc.loaded){
if (svc.failed){ svc.failed = false; svcPromise = null; }
loadService().then(function(){ if(activeTab==='service'){ renderScore(); render(); } });
}
tabsEl.querySelectorAll('.ke-rev-tab').forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-tab')===tab); });
zetFilter('all');
document.getElementById('ke-rev-sub').textContent = tab==='service' ? t.subSvc : t.subPrd;
renderScore();
render();
}

document.addEventListener('click',function(e){
var tr=e.target.closest('[data-ke-slideout-trigger]');
if(tr){e.preventDefault();openPanel(tr.getAttribute('data-ke-slideout-trigger')==='product'?'product':'service');return;}
var bar=e.target.closest('#ke-rev-bar');
if(bar){e.preventDefault();openPanel('product');}
});
closeBtn.addEventListener('click',closePanel);
overlay.addEventListener('click',function(e){if(e.target===overlay)closePanel();});

document.addEventListener('keydown',function(e){if(e.key==='Escape'&&panelOpen){closePanel();return;}if(e.key!=='Enter'&&e.key!==' ')return;var k=e.target.closest&&e.target.closest('[data-ke-slideout-trigger]');if(!k||k.classList.contains('ke-top-rating'))return;e.preventDefault();openPanel(k.getAttribute('data-ke-slideout-trigger')==='product'?'product':'service');});
tabsEl.addEventListener('click',function(e){var b=e.target.closest('.ke-rev-tab');if(!b)return;setTab(b.getAttribute('data-tab'));});

filters.addEventListener('click',function(e){var p=e.target.closest('.ke-rev-pill[data-filter]');if(!p)return;zetFilter(p.getAttribute('data-filter'));render();});

function zetFilter(f){activeFilter=f;panelSort=f==='helpful'?'helpful':'top';filters.querySelectorAll('.ke-rev-pill[data-filter]').forEach(function(x){x.classList.toggle('active',x.getAttribute('data-filter')===f);});mediaPil.classList.toggle('active',f==='media');sortPil.classList.toggle('active',f==='helpful');}
body.addEventListener('click', onTranslateClick);

function currentSet(){ return activeTab==='service' ? svc : prd; }

function renderScore(){
var scoreEl=document.getElementById('ke-rev-score');
var logoEl=document.getElementById('ke-rev-score-logo');
if(activeTab==='service'){
var g=svc.grade;
if(!g||!g.rating){scoreEl.style.display='none';return;}
logoEl.style.display='flex';

var label=[t.lab.p,t.lab.f,t.lab.g,t.lab.vg,t.lab.e][Math.max(1,Math.min(5,Math.round(g.rating)))-1];
document.getElementById('ke-rev-score-num').textContent=fmtScore(g.rating);
document.getElementById('ke-rev-score-stars').innerHTML=stars(g.rating,'ke-rev-stars');
document.getElementById('ke-rev-score-sub').textContent=label+(g.count?(' \u00b7 '+g.count.toLocaleString(LANG)+' '+t.reviews):'');
scoreEl.style.display='flex';
} else {
if(prd.average){
logoEl.style.display='none';
var label2=[t.lab.p,t.lab.f,t.lab.g,t.lab.vg,t.lab.e][Math.max(1,Math.min(5,Math.round(prd.average)))-1];
document.getElementById('ke-rev-score-num').textContent=fmtScore(prd.average);
document.getElementById('ke-rev-score-stars').innerHTML=stars(prd.average,'ke-rev-stars');
document.getElementById('ke-rev-score-sub').textContent=label2+' \u00b7 '+prd.total.toLocaleString(LANG)+' '+t.reviews;
scoreEl.style.display='flex';
} else { scoreEl.style.display='none'; }
}
}

function render(){
var set=currentSet();
if(set.failed){body.innerHTML='<p class="ke-rev-status">'+t.error+'</p>';return;}
if(!set.loaded){body.innerHTML='<p class="ke-rev-status">'+t.loading+'</p>';return;}
var items=set.items;
if(X.tellen)X.tellen(set.items,filters,t,LANG,activeTab);

var hoog=function(r){return Math.round(r.rating)>=4;}, metFoto=function(r){return hoog(r)&&fotoWaarde(r);};
var nFoto=set.items.filter(metFoto).length;
mediaPil.style.display=activeTab==='product'?'':'none';
mediaPil.disabled=!nFoto;
if(activeFilter==='media'&&!nFoto)zetFilter('all');
if(activeFilter==='media'){items=items.filter(metFoto);}
else if(activeFilter!=='all'&&activeFilter!=='helpful'){var f=parseInt(activeFilter,10);items=items.filter(function(r){return Math.round(r.rating)===f;});}
if(!items.length){body.innerHTML='<p class="ke-rev-status">'+(activeTab==='product'&&activeFilter==='all'?t.nonePrd:t.none)+'</p>';return;}
var isPrd=activeTab==='product';

if (panelSort === 'helpful') {
items = items.slice().sort(function(a,b){
var va=stemmenVan(a), vb=stemmenVan(b);
return (vb.u-vb.d)-(va.u-va.d) || String(b.date).localeCompare(String(a.date));
});
} else if (isPrd) {

items = items.slice().sort(function(a,b){
return ((b.comment?1:0)-(a.comment?1:0))
|| Math.min(Math.round(b.rating||0),4)-Math.min(Math.round(a.rating||0),4)
|| (fotoWaarde(b)-fotoWaarde(a))
|| String(b.date).localeCompare(String(a.date));
});
}
if(X.naSort)items=X.naSort(items,activeFilter,panelSort,stemmenVan);

items=(activeFilter==='all'?[items.filter(hoog),items.filter(function(r){return !hoog(r);})]:[items]).reduce(function(uit,g){
return uit.concat(g.filter(function(r){return taalVan(r)===LANG;}),g.filter(function(r){return taalVan(r)!==LANG;}));
},[]);
body.innerHTML=items.map(function(r){

var canTr = !!r.comment && taalVan(r) !== LANG;

return '<div class="ke-rev-card" data-id="'+esc(r.id)+'" data-showing="'+(r.translated ? 'trans' : 'orig')+'">'+
'<div class="ke-rev-card-top"><span>'+ (isPrd?srcMark(r.source):'') + stars(r.rating)+'</span>'+ (isPrd?'':verifiedHtml()) +'</div>'+
(r.title?'<div class="ke-rev-card-title">'+esc(r.title)+'</div>':'')+
'<div class="ke-rev-comment">'+esc(r.comment)+'</div>'+
fotoHtml(r)+
replyHtml(r)+
(isPrd ? byLine(r) : '')+
'<div class="ke-rev-meta">'+timeAgo(r.date)+
(isPrd && r.productName ? ' \u00b7 '+t.about+' '+esc(r.productName) : '')+'</div>'+
'<div class="ke-rev-foot">'+
(canTr?'<span class="ke-rev-tr"><button type="button" class="ke-rev-translate">'+(r.translated ? t.showOriginal : t.translate)+'</button><span class="ke-rev-tr-note">'+(r.translated ? esc(t.translatedFrom+' '+langName(r.srcLang)) : '')+'</span></span>':'<span></span>')+
stemUI(r)+
'</div>'+
'</div>';
}).join('');
fotoKijk(body);
}

function verifiedBadge(r){
if(r.source==='yotpo'){
var lbl = r.verifiedType==='buyer' ? t.verifiedBuyer : t.verifiedReviewer;
return verifiedHtml(lbl);
}
if(r.verified) return verifiedHtml(t.verifiedBuyer);
return '';
}
function verifiedHtml(label){
return '<span class="ke-rev-verified"><svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M9 12l2 2 4-4" stroke="#0C447C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="9" stroke="#0C447C" stroke-width="2"/></svg>'+esc(label||t.verified)+'</span>';
}

var ANON = { it:'Anonimo', nl:'Anoniem', de:'Anonym', fr:'Anonyme', es:'Anónimo' };
function naamVan(n){ n = String(n||''); return (ANON[LANG] && /^anonymous$/i.test(n.trim())) ? ANON[LANG] : n; }
function byLine(r){
var naam = r.name ? esc(naamVan(r.name)) : esc(t.kecust);
var lbl = r.source==='yotpo'
? (r.verifiedType==='buyer' ? t.verifiedBuyer : t.verifiedReviewer)
: (r.verified ? t.verifiedBuyer : t.verified);
return '<div class="ke-rev-by">'+esc(t.by)+' '+naam+',&nbsp;'+verifiedHtml(lbl)+'</div>';
}
function replyHtml(r){
if(!r.reply || !r.reply.c) return '';
return '<div class="ke-rev-reply"><span class="ke-rev-reply-t">'+esc(t.replyFrom)+'</span>'+
(r.reply.d?'<span class="ke-rev-reply-d">'+timeAgo(r.reply.d)+'</span>':'')+
'<p class="ke-rev-reply-c" data-reply>'+esc(r.reply.c)+'</p></div>';
}
function fotoWaarde(r){ return (r.photos&&r.photos.length) || r.foto ? 1 : 0; }

var fotoCache = {}, MAX_FOTO = 4;
function fotoThumbs(fotos, eigenaar){
fotos = (fotos || []).slice(0, MAX_FOTO);
fotoCache[eigenaar] = fotos;
var th = fotos.map(function(p, i){
return '<button type="button" class="ke-rev-photothumb" data-lb-id="'+esc(eigenaar)+'" data-lb-i="'+i+
'" aria-label="'+esc(t.photo)+'"><img src="'+esc(p.t||p.u)+'" loading="lazy" alt=""></button>';
}).join('');
if (fotos.length <= 3) return th;

return '<button type="button" class="ke-ph-ar" data-phv="-1" aria-label="previous">\u2039</button>'+
'<span class="ke-ph-strip">'+th+'</span>'+
'<button type="button" class="ke-ph-ar" data-phv="1" aria-label="next">\u203a</button>';
}

function fotoHtml(r){
if(r.photos && r.photos.length) return '<div class="ke-rev-photos">'+fotoThumbs(r.photos, r.id)+'</div>';
if(r.foto){
var al = fotoCache[r.id];
if(al) return al.length ? '<div class="ke-rev-photos">'+fotoThumbs(al, r.id)+'</div>' : '';
return '<div class="ke-rev-photos ke-rev-photos--wacht" data-tsfoto="'+esc(r.id)+'"><span class="ke-rev-photoph" aria-hidden="true"></span></div>';
}
return '';
}
var fotoLaden = {};
var fotoHaak = { klaar: null };
function haalFotos(id){
if(!fotoLaden[id]) fotoLaden[id] = fetch(PROXY_BASE+'?action=photo&id='+encodeURIComponent(id))
.then(function(r){ return r.json(); })
.then(function(d){ return (d && d.ok && d.photos) || []; })
["catch"](function(){ return []; });
return fotoLaden[id];
}
function vulFotoRij(w){
var id = w.getAttribute('data-tsfoto'); if(!id) return;
haalFotos(id).then(function(fotos){
fotos = fotos.slice(0, MAX_FOTO);
fotoCache[id] = fotos;

var rijen = document.querySelectorAll('[data-tsfoto]'), weg = false;
for(var i = 0; i < rijen.length; i++){
var rij = rijen[i]; if(rij.getAttribute('data-tsfoto') !== id) continue;
if(fotoIO) fotoIO.unobserve(rij);
rij.removeAttribute('data-tsfoto'); rij.classList.remove('ke-rev-photos--wacht');
if(fotos.length) rij.innerHTML = fotoThumbs(fotos, id);
else { rij.innerHTML = ''; rij.style.display = 'none'; weg = true; }
}

if(weg && typeof fotoHaak.klaar === 'function') fotoHaak.klaar();
});
}
var fotoIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function(en){
en.forEach(function(e){
if(!e.isIntersecting) return;
if(e.target.closest('#ke-rev-overlay') && !panelOpen) return;
fotoIO.unobserve(e.target);
vulFotoRij(e.target);
});
}, { rootMargin: '200px 0px' }) : null;

function fotoKijk(root){
var rijen = (root || document).querySelectorAll('[data-tsfoto]');
for(var i = 0; i < rijen.length; i++){
if(!fotoIO){ vulFotoRij(rijen[i]); continue; }
fotoIO.unobserve(rijen[i]); fotoIO.observe(rijen[i]);
}
}

var lbFotos = [], lbIdx = 0;
function lbRender(){
var lb = document.getElementById('ke-lb'); if(!lb) return;
var p = lbFotos[lbIdx]; if(!p) return;
lb.querySelector('img').src = p.u;
lb.querySelector('.ke-lb-c').textContent = (lbIdx+1)+' / '+lbFotos.length;
var een = lbFotos.length < 2;
lb.querySelector('.ke-lb-p').style.display = een ? 'none' : '';
lb.querySelector('.ke-lb-n').style.display = een ? 'none' : '';
}
function lbSluit(){ var lb=document.getElementById('ke-lb'); if(lb) lb.remove(); document.removeEventListener('keydown', lbToets); }
function lbStap(d){ lbIdx = (lbIdx + d + lbFotos.length) % lbFotos.length; lbRender(); }
function lbToets(e){
if(e.key==='Escape') return lbSluit();
if(e.key==='ArrowLeft') return lbStap(-1);
if(e.key==='ArrowRight') return lbStap(1);
}
function lbOpen(fotos, idx){
lbFotos = fotos || []; lbIdx = idx || 0;
if(!lbFotos.length) return;
lbSluit();
var lb = document.createElement('div');
lb.id = 'ke-lb'; lb.setAttribute('role','dialog'); lb.setAttribute('aria-modal','true');
lb.innerHTML = '<button type="button" class="ke-lb-x" aria-label="close">\u00d7</button>'+
'<button type="button" class="ke-lb-p" aria-label="previous">\u2039</button>'+
'<img alt="">'+
'<button type="button" class="ke-lb-n" aria-label="next">\u203a</button>'+
'<span class="ke-lb-c"></span>';
lb.addEventListener('click', function(e){
if(e.target === lb || e.target.closest('.ke-lb-x')) return lbSluit();
if(e.target.closest('.ke-lb-p')) return lbStap(-1);
if(e.target.closest('.ke-lb-n')) return lbStap(1);
});
document.body.appendChild(lb);
document.addEventListener('keydown', lbToets);
lbRender();
}

document.addEventListener('click', function(e){
var pv = e.target.closest('[data-phv]');
if (pv){
var strook = pv.parentElement.querySelector('.ke-ph-strip');
if (strook) strook.scrollBy({ left: parseInt(pv.getAttribute('data-phv'),10) * 128, behavior: 'smooth' });
return;
}
var th = e.target.closest('[data-lb-id]'); if(!th) return;
e.preventDefault();
lbOpen(fotoCache[th.getAttribute('data-lb-id')] || [], parseInt(th.getAttribute('data-lb-i'),10) || 0);
});

function applyTrans(card, obj, src){
var c=card.querySelector('.ke-rev-comment'), ti=card.querySelector('.ke-rev-card-title'),
note=card.querySelector('.ke-rev-tr-note'), btn=card.querySelector('.ke-rev-translate');
c.textContent=obj.comment;
if(ti && obj.title) ti.textContent=obj.title;
var rp=card.querySelector('[data-reply]');
if(rp && obj.reply) rp.textContent=obj.reply;
note.textContent=t.translatedFrom+' '+langName(src);
btn.textContent=t.showOriginal;
card.setAttribute('data-showing','trans');
}
function translateReview(id, isProduct){
var u = PROXY_BASE + "?action=translate&country=" + encodeURIComponent(COUNTRY) +
"&lang=" + encodeURIComponent(LANG) + "&to=" + encodeURIComponent(LANG) +
"&id=" + encodeURIComponent(id);
if(isProduct) u += "&sku=" + encodeURIComponent(SKU) + "&yotpo=" + encodeURIComponent(YOTPO_ID);
return fetch(u).then(function(res){ return res.json(); })
.then(function(d){ return { comment:(d&&d.comment)||"", title:(d&&d.title)||"", reply:(d&&d.reply)||"", ok:!!(d&&d.ok) }; });
}
function onTranslateClick(e){

var duim=e.target.closest('[data-vote]');
if (duim) return opStem(duim);
var btn=e.target.closest('.ke-rev-translate'); if(!btn) return;
var card=btn.closest('.ke-rev-card'); var id=card.getAttribute('data-id');
var set=currentSet(); var r=set.byId[id]; if(!r) return;
var c=card.querySelector('.ke-rev-comment'), ti=card.querySelector('.ke-rev-card-title'), note=card.querySelector('.ke-rev-tr-note');
if(card.getAttribute('data-showing')==='trans'){

c.textContent=(r.orig&&r.orig.comment)||r.comment; if(ti) ti.textContent=(r.orig&&r.orig.title)||r.title; note.textContent=''; btn.textContent=t.translate;
var rp0=card.querySelector('[data-reply]'); if(rp0&&r.reply) rp0.textContent=r.reply.c;
card.setAttribute('data-showing','orig'); return;
}
var ck=id+'|'+LANG;
if(r.translated && r.orig){ applyTrans(card, {comment:r.comment, title:r.title, reply:(r.reply&&r.reply.c)||''}, r.srcLang); return; }
if(transCache[ck]){ applyTrans(card, transCache[ck], r.srcLang); return; }
btn.textContent=t.translating; btn.disabled=true;
translateReview(id, activeTab==='product').then(function(res){
btn.disabled=false;
if(!res.ok){ btn.textContent=t.translate; note.textContent=t.translateFailed; return; }
var obj={comment:res.comment, title:res.title, reply:res.reply};
transCache[ck]=obj;
applyTrans(card,obj,r.srcLang);
}).catch(function(){ btn.disabled=false; btn.textContent=t.translate; });
}

var USP_TPL = document.getElementById('ke-pdp-usp'), uspKlaar = false;
function zetUsp(html){
var els = document.querySelectorAll('[data-ke-slideout-trigger="'+TRIGGER_ID+'"] .text-with-icon-block__text');
if(!html || !els.length) return false;
for(var i = 0; i < els.length; i++){ els[i].innerHTML = html; els[i].setAttribute('data-ke-usp', 'blok1'); }
return true;
}
function uspUitMetaobject(){
if(!uspKlaar && USP_TPL) uspKlaar = zetUsp(USP_TPL.innerHTML.trim());
}

function updateUsp(g){
if(uspKlaar || !g || !g.rating || !g.count || !USP_TPL) return;
var a = function(k){ return USP_TPL.getAttribute('data-' + k) || ''; };
var r = Number(g.rating), r2 = Math.round(r * 100) / 100, r0 = Math.round(r);
var cijfer = String(r2 === r0 ? r0 : r2);
if(LANG !== 'en') cijfer = cijfer.replace('.', ',');
var label = a('labels').split(',')[Math.max(1, Math.min(5, r0)) - 1] || '';
var aantal = String(Math.round(g.count)).replace(/\B(?=(\d{3})+(?!\d))/g, a('sep'));
uspKlaar = zetUsp('<p>' + esc(label) + ' <strong>' + cijfer + '/5</strong>' + esc(a('door') + aantal + a('klant')) + '</p>');
}
uspUitMetaobject();

document.addEventListener('shopify:section:load', function(){ uspKlaar = false; uspUitMetaobject(); });

function placeBar(bar, trigger){
var card = trigger.closest('.group-block.border');
if (card && card.parentElement) { card.insertAdjacentElement('afterend', bar); return true; }
var aside = trigger.closest('.product-information__aside');
if (aside) { aside.appendChild(bar); return true; }
var list = trigger.parentElement;
if (list) { list.insertAdjacentElement('afterend', bar); return true; }
return false;
}

function reserveBar(){
if(document.getElementById('ke-rev-slot'))return null;
var trigger=document.querySelector('[data-ke-slideout-trigger="'+TRIGGER_ID+'"]');
if(!trigger)return null;

var slot=document.createElement('div');
slot.id='ke-rev-slot'; slot.className='ke-rev-slot';
var bar=document.createElement('div');
bar.id='ke-rev-bar'; bar.className='ke-rev-bar ke-rev-bar--loading';
bar.setAttribute('role','button'); bar.setAttribute('tabindex','0');
bar.setAttribute('aria-busy','true');
bar.innerHTML='<div class="ke-rev-bar-score">'+
'<span class="ke-rev-skel ke-rev-skel--stars"></span>'+
'</div>'+
'<div class="ke-rev-bar-quote" id="ke-rev-bar-quote">'+
'<span class="ke-rev-skel ke-rev-skel--line1"></span>'+
'</div>'+
'<span class="ke-rev-bar-arrow">\u203A</span>';
slot.appendChild(bar);
if(!placeBar(slot, trigger))return null;
return bar;
}

function rmBar(){
var s=document.getElementById('ke-rev-slot');
if(s){ s.remove(); return; }
var b=document.getElementById('ke-rev-bar');
if(b) b.remove();
}

function buildBar(){
var bar=document.getElementById('ke-rev-bar');
if(!bar) bar=reserveBar();
if(!bar)return;

if(prd.total < 1){ rmBar(); return; }
bar.classList.remove('ke-rev-bar--loading');
bar.removeAttribute('aria-busy');

var heeftCitaat = (prd.barQuotes||[]).some(function(q){ return q && q.text; });
if(!heeftCitaat && !prd.translating){ rmBar(); return; }
bar.innerHTML =
'<div class="ke-rev-bar-quote" id="ke-rev-bar-quote"></div>'+
'<span class="ke-rev-bar-arrow">\u203A</span>';
bar.classList.add('is-ready');

bar.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){e.preventDefault();openPanel('product');} });

bar.addEventListener('mouseenter',function(){ if(panelOpen)return; stopBar(); });
bar.addEventListener('mouseleave',function(){ if(panelOpen)return; startBar(); });
bar.addEventListener('focus',function(){ if(panelOpen)return; stopBar(); });
bar.addEventListener('blur',function(){ if(panelOpen)return; startBar(); });

buildSlides();
barIdx=0;

requestAnimationFrame(function(){
var slot=document.getElementById('ke-rev-slot');
if(slot && bar.offsetHeight) slot.style.height = bar.offsetHeight + 'px';
});

if('IntersectionObserver' in window){
barObserver=new IntersectionObserver(function(entries){
barVisible = entries[0] && entries[0].isIntersecting;
if(barVisible) startBar(); else stopBar();
},{threshold:0.1});
barObserver.observe(bar);
}

if(!(prd.barQuotes||[]).length && prd.translating){

showQuoteSkeleton();
pollQuotes(0);
} else {
renderSlideNow(0);
startBar();
}
}

function slideMark(src){
return src==='ts' ? '<span class="ke-rev-src ke-rev-src-ts" title="Trusted Shops">e</span>'
: src==='yotpo' ? '<span class="ke-rev-src ke-rev-src-ke" title="Kamera Express">K</span>' : '';
}

function slideHtml(s){
if(!s.src) return s.html;

var cij = s.r || prd.average || (MO && MO.score) || 0;
var pre = (cij ? '<span class="ke-bar-r">'+fmtScore(cij)+'/5</span>' : '');
pre += '<span class="ke-bar-nm">'+esc(naamVan(s.nm) || t.verifiedBuyer)+'</span>';
return pre + slideMark(s.src) + s.html;
}

function suppressBar(on){
var bar=document.getElementById('ke-rev-bar');
if(!bar)return;
if(on) bar.classList.add('is-suppressed');
else   bar.classList.remove('is-suppressed');
}

function buildSlides(){
barSlides = [];
(prd.barQuotes||[]).forEach(function(q){
barSlides.push({
src:q.source, r:q.r||0, nm:q.nm||'',
html:'<span class="ke-rev-bar-text">\u201C'+esc(q.text)+'\u201D</span>',
full:q.full || q.text
});
});
if(!barSlides.length){ barSlides.push({src:null, html:'', full:''}); }
}

function showQuoteSkeleton(){
var el=document.getElementById('ke-rev-bar-quote');
if(!el)return;
el.style.opacity='1';
el.innerHTML='<span class="ke-rev-skel ke-rev-skel--quote"></span>';
}
function clearQuoteSkeleton(){

if(!barSlides.length || !barSlides[0].src){ rmBar(); return; }
barIdx=0; renderSlideNow(0); startBar();
}

function pollQuotes(attempt){
if(pollTimer){clearTimeout(pollTimer);pollTimer=null;}
if(attempt>2){ clearQuoteSkeleton(); return; }
pollTimer=setTimeout(function(){

(attempt ? fetch(PRODUCT_URL+'&_r='+Date.now(),{cache:'no-store'}).then(function(r){return r.json();}) : prdData())
.then(function(d){
if(d && (d.barQuotes||[]).length){
prd.barQuotes=d.barQuotes;
buildSlides();
var el=document.getElementById('ke-rev-bar-quote');
if(el) el.style.opacity='0';
setTimeout(function(){
barIdx=0; renderSlideNow(0);
var e2=document.getElementById('ke-rev-bar-quote');
if(e2) e2.style.opacity='1';
startBar();
},160);
} else if(d && d.translating){
pollQuotes(attempt+1);
} else {
clearQuoteSkeleton();
}
})
.catch(function(){ clearQuoteSkeleton(); });
}, 900 + attempt*1400);
}

function renderSlideNow(i){
var el=document.getElementById('ke-rev-bar-quote');
if(el && barSlides[i]) el.innerHTML=slideHtml(barSlides[i]);
}
function renderSlide(i){
var el=document.getElementById('ke-rev-bar-quote');
if(!el||!barSlides.length)return;
el.style.opacity='0';
setTimeout(function(){ el.innerHTML=slideHtml(barSlides[i]); el.style.opacity='1'; },260);
}
function startBar(){
if(REDUCED)return;
if(barTimer||barSlides.length<2||panelOpen||!barVisible)return;
barTimer=setInterval(function(){ barIdx=(barIdx+1)%barSlides.length; renderSlide(barIdx); },BAR_ROTATE_MS);
}
function stopBar(){ if(barTimer){clearInterval(barTimer);barTimer=null;} }

function indexById(set){ set.byId={}; set.items.forEach(function(r){set.byId[r.id]=r;}); }

function loadService(){
return svcData().then(function(data){
if(!data || data.error){svc.failed=true;svc.loaded=true;return;}
svc.items=data.items||[]; svc.grade=data.grade||null; svc.loaded=true; indexById(svc);
updateUsp(svc.grade);
}).catch(function(){svc.failed=true;svc.loaded=true;});
}
function loadProduct(){
return prdData().then(function(data){
if(!data || data.error){prd.failed=true;prd.loaded=true;return;}
prd.items=data.items||[]; prd.total=data.total||0; prd.average=data.average||null;
var rated=prd.items.filter(function(r){return typeof r.rating==='number'&&r.rating>0;});
prd.rawAverage = rated.length ? rated.reduce(function(a,r){return a+r.rating;},0)/rated.length : 0;
prd.barQuotes=data.barQuotes||[]; prd.translating=!!data.translating;
prd.loaded=true; indexById(prd);
buildBar();
}).catch(function(){prd.failed=true;prd.loaded=true;});
}

function loadProductFull(){
if (prdFullPromise) return prdFullPromise;
prdFullPromise = fetch(PRODUCT_FULL_URL).then(function(r){return r.json();})
.then(function(data){
if(!data || data.error || !data.items) return;
prd.fullLoaded = true; prd.partial = false;
prd.items = data.items;
prd.total = data.total || prd.total;
prd.average = (data.average != null) ? data.average : prd.average;
var rated = prd.items.filter(function(r){return typeof r.rating==='number'&&r.rating>0;});
prd.rawAverage = rated.length ? rated.reduce(function(a,r){return a+r.rating;},0)/rated.length : 0;
prd.metrics = data.metrics || prd.metrics;

stemPot.product = prd.votes = (data.votes || {});
versVotes(SKU, stemPot.product);
prd.loaded = true;
indexById(prd);
if (panelOpen && activeTab === 'product') { renderScore(); render(); }
if (window.KEReviewsSection && window.KEReviewsSection.onData) window.KEReviewsSection.onData();
}).catch(function(){  });
return prdFullPromise;
}

function loadProductFirst(){
if (prdFullPromise && prd.fullLoaded) return prdFullPromise;
return prdData().then(function(data){
if (prd.fullLoaded || !data || data.error || !data.items) return;
prd.items = data.items; prd.total = data.total || prd.total; prd.partial = true; prd.loaded = true; indexById(prd);
});
}

function buildBarFromMetaobject(){
prd.total = MO.count;
prd.average = MO.count >= 3 ? MO.score : null;
prd.rawAverage = MO.score;
var list = (MO.bar && MO.bar[LANG]) || [];
prd.barQuotes = list.map(function(q){

return { id: null, source: q.src === 'y' ? 'yotpo' : 'ts', text: q.text, full: q.text,
r: q.r || 0, nm: q.nm || '' };
});

prd.translating = !prd.barQuotes.length && MO.count > 0;
buildBar();
}

function loadData(){
reserveBar();

if (MO){

buildBarFromMetaobject();
} else {

loadProduct().then(function(){ if (panelOpen) setTab(activeTab); });
}

var uspDone = false;
var fillUsp = function(){
if (uspDone) return; uspDone = true;
loadService().catch(function(){});
};
uspUitMetaobject();
if (uspKlaar || !document.querySelector('[data-ke-slideout-trigger="'+TRIGGER_ID+'"] .text-with-icon-block__text')) uspDone = true;
else if ('requestIdleCallback' in window) requestIdleCallback(fillUsp, { timeout: 4000 });
else setTimeout(fillUsp, 2500);

(function(){
var triggers = [document.getElementById('ke-rev-bar'),
document.querySelector('.ke-rev-tab[data-tab="service"]'),
document.querySelector('[data-ke-slideout-trigger="'+TRIGGER_ID+'"]')];
for (var i = 0; i < triggers.length; i++){
if (!triggers[i]) continue;
triggers[i].addEventListener('pointerenter', function(){ svcData(); }, { once: true });
triggers[i].addEventListener('touchstart',  function(){ svcData(); }, { once: true, passive: true });
}
})();

var api = {
t: t, LANG: LANG, KE_LOGO: KE_LOGO, MO: MO, prd: prd, transCache: transCache,
PROXY_BASE: PROXY_BASE, SKU: SKU, MODEL_KEY: MODEL_KEY, USED: USED, COUNTRY: COUNTRY, stemToken: stemToken,
stars: stars, esc: esc, fmtScore: fmtScore, timeAgo: timeAgo,
srcMark: srcMark, verifiedBadge: verifiedBadge, verifiedHtml: verifiedHtml,
byLine: byLine, replyHtml: replyHtml, fotoHtml: fotoHtml, fotoKijk: fotoKijk, fotoWaarde: fotoWaarde, lbOpen: lbOpen,
fotoHaak: fotoHaak,
translateReview: translateReview, loadProductFull: loadProductFull, loadProductFirst: loadProductFirst,
svc: svcData
};
var wachtrij = window.KE_SECTION_QUEUE || [];
window.KE_SECTION_QUEUE = { push: function (fn) { fn(api); } };
wachtrij.forEach(function (fn) { fn(api); });
}

if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',loadData); }
else { loadData(); }
})();
} catch (e) { console.error('KE Reviews pdp:', e); }
/* sterren (4sterrencode.liquid) */
if (__KE_C["sterren"]) try {
(function(){

var el = document.querySelector('.ke-top-rating[data-ke-slideout-trigger]');
if (!el) return;
el.addEventListener('keydown', function(e){
if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
});
if (location.hash === '#ke-reviews-section') {
window.addEventListener('load', function(){ setTimeout(function(){ el.click(); }, 300); });
}
})();
} catch (e) { console.error('KE Reviews sterren:', e); }
/* sectie (2Custom_review_blok.liquid) */
if (__KE_C["sectie"]) try {
(function () {

(window.KE_SECTION_QUEUE = window.KE_SECTION_QUEUE || []).push(function (ke) {
var t = ke.t, LANG = ke.LANG, KE_LOGO = ke.KE_LOGO, MO = ke.MO, prd = ke.prd;
var transCache = ke.transCache;
var stars = ke.stars, esc = ke.esc, fmtScore = ke.fmtScore, timeAgo = ke.timeAgo;
var srcMark = ke.srcMark, verifiedBadge = ke.verifiedBadge;
var byLine = ke.byLine, replyHtml = ke.replyHtml, fotoHtml = ke.fotoHtml;
var fotoWaarde = ke.fotoWaarde;

var fotoKijk = ke.fotoKijk || function(){};
if (ke.fotoHaak) ke.fotoHaak.klaar = function(){ zetLeesMeer(); };
var translateReview = ke.translateReview, loadProductFull = ke.loadProductFull;
var PROXY_BASE = ke.PROXY_BASE, SKU_FOR_VOTES = ke.SKU;
var stemToken = ke.stemToken || function(){ return ''; };

var secEl = null, secFilter = 'all', secLoaded = false;
var secToonConditie = false;

var SVC_T = {
nl:{aanbod:"Bekijk beoordelingen over onze winkel",
kop:"Beoordelingen over onze winkel en service",
niet:"Deze gaan over de service van Kamera Express, niet over dit product.",
minder:"Minder tonen",meer:"Meer tonen",
terug:"Terug naar productreviews",
toon:"{n} van {m} reviews getoond",sterren:"Sterren",details:"Details"},
en:{aanbod:"See reviews about our store",
kop:"Reviews about our store and service",
niet:"These are about the service of Kamera Express, not about this product.",
minder:"Show less",meer:"Show more",
terug:"Back to product reviews",
toon:"Showing {n} of {m} reviews",sterren:"Stars",details:"Details"},
de:{aanbod:"Bewertungen \u00fcber unseren Shop ansehen",
kop:"Bewertungen \u00fcber Shop und Service",
niet:"Diese betreffen den Service von Kamera Express, nicht dieses Produkt.",
minder:"Weniger anzeigen",meer:"Mehr anzeigen",
terug:"Zur\u00fcck zu den Produktbewertungen",
toon:"{n} von {m} Bewertungen angezeigt",sterren:"Sterne",details:"Details"},
fr:{aanbod:"Voir les avis sur notre boutique",
kop:"Avis sur notre boutique et notre service",
niet:"Ils concernent le service de Kamera Express, pas ce produit.",
minder:"Afficher moins",meer:"Afficher plus",
terug:"Retour aux avis produit",
toon:"{n} avis sur {m} affich\u00e9s",sterren:"\u00c9toiles",details:"D\u00e9tails"},
es:{aanbod:"Ver rese\u00f1as sobre nuestra tienda",
kop:"Rese\u00f1as sobre nuestra tienda y servicio",
niet:"Se refieren al servicio de Kamera Express, no a este producto.",
minder:"Mostrar menos",meer:"Mostrar m\u00e1s",
terug:"Volver a las rese\u00f1as del producto",
toon:"Mostrando {n} de {m} rese\u00f1as",sterren:"Estrellas",details:"Detalles"},
it:{aanbod:"Vedi le recensioni sul nostro negozio",
kop:"Recensioni sul nostro negozio e servizio",
niet:"Riguardano il servizio di Kamera Express, non questo prodotto.",
minder:"Mostra meno",meer:"Mostra altro",
terug:"Torna alle recensioni del prodotto",
toon:"{n} recensioni su {m} mostrate",sterren:"Stelle",details:"Dettagli"}
};
var st = SVC_T[LANG] || SVC_T.en;

var METRIC_T = (window.KE_SEC_T && window.KE_SEC_T.METRIC) || {};
var mt = METRIC_T[LANG] || {};
function metricTitel(x){ return mt[x] || x; }
var secSvcMode = false;
var secSvcItems = null;
var secSvcById = {};

var SVC_VOTE_KEY = 'svc-' + (ke.COUNTRY || 'nl');
var secSvcVotes = {};
var secSvcFilter = 'all';
var secSort = 'high';
var secTab = 'all', secTabAuto = true;

var isTweedehands = !!(ke.USED || ke.MODEL_KEY);
var mijnStemmen = {};
try { mijnStemmen = JSON.parse(localStorage.getItem('ke-rev-votes') || '{}'); } catch (e) {}
function bewaarStemmen() {
try { localStorage.setItem('ke-rev-votes', JSON.stringify(mijnStemmen)); } catch (e) {}
}

function findSectionHost(){
return document.getElementById('ke-reviews-section');
}

function hideYotpoMain(){
var kandidaten = document.querySelectorAll(
'.yotpo-reviews-main-widget, .yotpo-main-widget, #yotpo-reviews-main-widget, ' +
'.yotpo-widget-instance');
var verborgen = 0;
Array.prototype.forEach.call(kandidaten, function(el){
if (el.closest('#ke-reviews-section')) return;
if (el.offsetHeight < 150) return;
el.style.position = 'absolute'; el.style.left = '-9999px';
el.style.width = '1px'; el.style.height = '1px'; el.style.overflow = 'hidden';
el.setAttribute('aria-hidden','true');
el.setAttribute('data-ke-hidden','1');
verborgen++;
});
return verborgen;
}

function mountSection(){
var host = findSectionHost();
if (!host || host.getAttribute('data-ke-mounted')) return null;
var tpl = document.getElementById('ke-rev-section-tpl');
if (!tpl) return null;
host.appendChild(tpl.content.cloneNode(true));
host.setAttribute('data-ke-mounted','1');
secEl = document.getElementById('ke-sec');

document.getElementById('ke-sec-write').textContent = t.write;
document.getElementById('ke-sec-sortlabel').textContent = t.sortBy;
var sel = document.getElementById('ke-sec-sort');

[['high',t.sortHigh],['low',t.sortLow],['helpful',t.sortHelpful],['recent',t.sortRecent],['media',t.metFoto||'With photos']]
.forEach(function(o){ var op=document.createElement('option'); op.value=o[0]; op.textContent=o[1]; sel.appendChild(op); });
sel.addEventListener('change', function(){
secSort = sel.value;

if (secSort === 'helpful' || secSort === 'media') secFilter = 'all';
renderSection();
});
document.getElementById('ke-sec-tabs').addEventListener('click', function(e){
var b = e.target.closest('[data-tab]'); if(!b) return;
secTab = b.getAttribute('data-tab'); secTabAuto = false; renderSection();
});
document.getElementById('ke-sec-dist').addEventListener('click', function(e){
var b = e.target.closest('[data-sfilter]'); if(!b) return;
var v = b.getAttribute('data-sfilter');
secFilter = (secFilter === v) ? 'all' : v;

if (secFilter !== 'all' && (secSort === 'helpful' || secSort === 'media')) { secSort = 'high'; sel.value = 'high'; }
renderSection();
});
document.getElementById('ke-sec-active').addEventListener('click', function(e){
if (!e.target.closest('[data-clearfilter]')) return;
secFilter = 'all'; renderSection();
});

var seg = document.getElementById('ke-sec-seg');
document.getElementById('ke-sec-tab-dist').textContent = st.sterren;
document.getElementById('ke-sec-tab-metrics').textContent = st.details;
function kiesPane(k){
seg.setAttribute('data-tab', k);
var tabs = seg.querySelectorAll('[role=tab]');
for (var ti = 0; ti < tabs.length; ti++){
var aan = tabs[ti].getAttribute('data-seg') === k;
tabs[ti].setAttribute('aria-selected', aan ? 'true' : 'false');
tabs[ti].tabIndex = aan ? 0 : -1;
}
document.getElementById('ke-sec-pane-dist').setAttribute('aria-hidden', k !== 'dist');
document.getElementById('ke-sec-pane-metrics').setAttribute('aria-hidden', k !== 'metrics');
}
seg.addEventListener('click', function(e){ var b = e.target.closest('[data-seg]'); if (b) kiesPane(b.getAttribute('data-seg')); });
seg.addEventListener('keydown', function(e){
if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
var k = seg.getAttribute('data-tab') === 'dist' ? 'metrics' : 'dist';
kiesPane(k); seg.querySelector('[data-seg="' + k + '"]').focus(); e.preventDefault();
});

document.getElementById('ke-sec-morelabel').textContent = st.meer;
document.getElementById('ke-sec-lesslabel').textContent = st.minder;
document.getElementById('ke-sec-more').addEventListener('click', function(){
var eerste = meerKaarten(true);
var kaart = eerste === false ? null : document.getElementById('ke-sec-list').children[eerste];
if (kaart){ kaart.setAttribute('tabindex', '-1'); kaart.focus({ preventScroll: true }); }
});
document.getElementById('ke-sec-less').addEventListener('click', minderKaarten);

var klemTimer = null;
window.addEventListener('resize', function(){ clearTimeout(klemTimer); klemTimer = setTimeout(zetLeesMeer, 120); });

document.getElementById('ke-sec-write').addEventListener('click', clickYotpoWrite);
secEl.addEventListener('click', onSectionClick);
return secEl;
}

function clickYotpoWrite(){
var sels = ['.write-review-button','.yotpo-review-button','[data-testid="write-review-button"]',
'.yotpo-widget-instance button.yotpo-new-review-btn','.yotpo-new-review-btn'];
for (var i=0;i<sels.length;i++){
var b = document.querySelector(sels[i]);
if (b){ b.click(); return; }
}

var host = document.querySelector('[data-ke-hidden="1"]');
if (host){ host.style.position=''; host.style.left=''; host.style.width='';
host.style.height=''; host.style.overflow='';
host.setAttribute('data-ke-show','1');
host.removeAttribute('aria-hidden'); host.removeAttribute('data-ke-hidden');
host.scrollIntoView({behavior:'smooth', block:'center'}); }
}

function metricBars(fields, prefix){
if (!fields) return '';
var rows = [];
for (var k in fields){
var f = fields[k];
if (!f || !f.title) continue;
var val = (f.value != null) ? f.value : f.average_score;
if (val == null) continue;
if (f.field_type && f.field_type !== 'Rating'){
rows.push('<div class="ke-metric"><span class="ke-metric-t">'+esc(metricTitel(f.title))+'</span>'+
'<span class="ke-metric-v">'+esc(String(val))+'</span></div>');
continue;
}
var pct = Math.max(0, Math.min(100, (parseFloat(val)/5)*100));
rows.push('<div class="ke-metric"><span class="ke-metric-t">'+esc(metricTitel(f.title))+'</span>'+
'<span class="ke-metric-bar"><i style="width:'+pct+'%"></i></span>'+
'<span class="ke-metric-v">'+fmtScore(parseFloat(val))+'</span></div>');
}
if (!rows.length) return '';
return '<div class="'+(prefix||'ke-metrics')+'">'+rows.join('')+'</div>';
}

function verdeling(items){
var d = {1:0,2:0,3:0,4:0,5:0};
items.forEach(function(r){ var k=Math.round(r.rating||0); if(d[k]!==undefined) d[k]++; });
return d;
}

function stemmenVan(r){
var basisU = r.source === 'yotpo' ? (r.votesUp||0) : 0;
var basisD = r.source === 'yotpo' ? (r.votesDown||0) : 0;

var v = (secSvcMode ? secSvcVotes : (prd.votes || {}))[r.id] || {};
return { u: Math.max(0, basisU + (v.u||0)), d: Math.max(0, basisD + (v.d||0)) };
}

function taalVan(r){ var H=window.KE_H; return r.lang || (H && H.taal && H.taal((r.title||'')+' '+(r.comment||''))) || r.srcLang || ''; }
function eigenTaal(r){ return taalVan(r) === LANG ? 1 : 0; }
function sorteer(items){
var kopie = items.slice();
if (secSort === 'helpful') {
kopie.sort(function(a,b){
var va=stemmenVan(a), vb=stemmenVan(b);
return (vb.u - vb.d) - (va.u - va.d) || String(b.date).localeCompare(String(a.date));
});
} else if (secSort === 'high' || secSort === 'media') {

kopie.sort(function(a,b){
return ((b.comment?1:0)-(a.comment?1:0))
|| (b.rating||0)-(a.rating||0)
|| (eigenTaal(b)-eigenTaal(a))
|| (fotoWaarde(b)-fotoWaarde(a))
|| String(b.date).localeCompare(String(a.date));
});
} else if (secSort === 'low') {
kopie.sort(function(a,b){ return (a.rating||0)-(b.rating||0) || String(b.date).localeCompare(String(a.date)); });
} else {
kopie.sort(function(a,b){ return String(b.date).localeCompare(String(a.date)); });
}
return kopie;
}

function renderSection(){
if (!secEl) return;

var kop  = document.getElementById('ke-sec-svchead');
var top  = secEl.querySelector('.ke-sec-top');
var mets = document.getElementById('ke-sec-metrics');
var tabs = document.getElementById('ke-sec-tabs');
var bar  = secEl.querySelector('.ke-sec-toolbar');
if (secSvcMode) {

top.hidden = true; mets.hidden = true; tabs.hidden = true; bar.hidden = false;
kop.hidden = false;
var alle = secSvcItems || [];
var perSter = {};
for (var q = 0; q < alle.length; q++) {
var ster = Math.round(alle[q].rating) || 0;
perSter[ster] = (perSter[ster] || 0) + 1;
}
var knoppen = '<button type="button" class="ke-sec-svcf'+(secSvcFilter==='all'?' actief':'')+
'" data-svcf="all">'+esc(t.all)+' ('+alle.length+')</button>';
for (var ss = 5; ss >= 1; ss--) {
if (!perSter[ss]) continue;
knoppen += '<button type="button" class="ke-sec-svcf'+(secSvcFilter===String(ss)?' actief':'')+
'" data-svcf="'+ss+'">'+ss+'\u2605 ('+perSter[ss]+')</button>';
}
kop.innerHTML =
'<h3 class="ke-sec-svctitle">'+esc(st.kop)+'</h3>'+
'<p class="ke-sec-svcnote">'+esc(st.niet)+'</p>'+
'<button type="button" class="ke-sec-svcback" id="ke-sec-svcterug">'+
esc(st.terug)+'</button>'+
'<div class="ke-sec-svcfilters">'+knoppen+'</div>';
var lijst = document.getElementById('ke-sec-list');
var svc = alle;
if (secSvcFilter !== 'all') {
var fs = parseInt(secSvcFilter, 10);
svc = svc.filter(function(r){ return Math.round(r.rating) === fs; });
}
svc = sorteer(svc);

if (svc.length) toonReeks(lijst, svc, serviceCard);
else { secLijst = []; secGetoond = 0; lijst.innerHTML = '<p class="ke-rev-status">'+esc(t.none)+'</p>'; leegKnoppen(); }

document.getElementById('ke-sec-svcfootrow').innerHTML =
svc.length ? esc(t.powered)+' <strong>Trusted Shops</strong>' : '';
zetLeesMeer();
return;
}
top.hidden = false; mets.hidden = false; tabs.hidden = false;
bar.hidden = false; kop.hidden = true;

var alles = prd.items || [];

var aantalUsed = alles.filter(function(r){ return r.conditie === 'used'; }).length;
var aantalNieuw = alles.length - aantalUsed;
var tabsEl = document.getElementById('ke-sec-tabs');

secToonConditie = isTweedehands || !!(aantalUsed && aantalNieuw);
if (aantalUsed && aantalNieuw) {
var volgorde = isTweedehands ? ['used','new','all'] : ['new','used','all'];
var labels = { used: t.tabUsed, "new": t.tabNew, all: t.tabAll };
var tellers = { used: aantalUsed, "new": aantalNieuw, all: alles.length };
if (secTabAuto && isTweedehands) secTab = 'used';
tabsEl.innerHTML = volgorde.map(function(k){
return '<button type="button" class="ke-sec-tab'+(secTab===k?' active':'')+
'" data-tab="'+k+'">'+esc(labels[k])+'<span>'+tellers[k]+'</span></button>';
}).join('');
tabsEl.style.display = '';
} else {
tabsEl.style.display = 'none';
secTab = 'all';
}

secEl.classList.toggle('ke-sec--th', isTweedehands && !!(aantalUsed && aantalNieuw));
if (secTab === 'used') alles = alles.filter(function(r){ return r.conditie === 'used'; });
else if (secTab === 'new') alles = alles.filter(function(r){ return r.conditie !== 'used'; });

var avg = (MO ? MO.score : (prd.average || prd.rawAverage)) || 0;
var cnt = (MO ? MO.count : prd.total) || 0;
if (secTab !== 'all' && MO && MO.split) {
var g = secTab === 'used' ? MO.split.used : MO.split.nieuw;
if (g && g.count) { avg = g.score || 0; cnt = g.count; }
}
document.getElementById('ke-sec-num').textContent = cnt > 0 ? fmtScore(avg) : '—';
document.getElementById('ke-sec-stars').innerHTML = stars(avg,'ke-rev-stars');
document.getElementById('ke-sec-count').textContent = cnt.toLocaleString(LANG)+' '+t.reviews;
document.getElementById('ke-sec-metrics').innerHTML = metricBars(prd.metrics, 'ke-metrics ke-metrics--avg');
var d = verdeling(alles);
var maxd = Math.max(1, d[1],d[2],d[3],d[4],d[5]);
var rijen = [];
for (var ster = 5; ster >= 1; ster--) {
var aantal = d[ster];
var pct = Math.round((aantal / maxd) * 100);
var actief = secFilter === String(ster);
rijen.push('<button type="button" class="ke-dist-row'+(actief?' active':'')+
'" data-sfilter="'+ster+'"'+(aantal?'':' disabled')+'>'+
'<span class="ke-dist-label">'+ster+'<span class="ke-dist-star">\u2605</span></span>'+
'<span class="ke-dist-bar"><i style="width:'+pct+'%"></i></span>'+
'<span class="ke-dist-n">'+aantal+'</span></button>');
}

var geenReviews = !cnt && !alles.length;
document.getElementById('ke-sec-seg').style.display = geenReviews ? 'none' : '';
document.getElementById('ke-sec-panes').style.display = geenReviews ? 'none' : '';
document.getElementById('ke-sec-dist').innerHTML = geenReviews ? '' : rijen.join('');

var items = alles;

var metFotoLijst = alles.filter(function(r){ return Math.round(r.rating) >= 4 && fotoWaarde(r); });
var selS = document.getElementById('ke-sec-sort'), optM = selS && selS.querySelector('option[value="media"]');
if (optM) optM.disabled = !metFotoLijst.length;
if (secSort === 'media' && !metFotoLijst.length) { secSort = 'high'; if (selS) selS.value = 'high'; }
if (secSort === 'media') items = metFotoLijst;
if (secFilter !== 'all') {
var f = parseInt(secFilter,10);
items = items.filter(function(r){ return Math.round(r.rating) === f; });
}
document.getElementById('ke-sec-active').innerHTML = secFilter === 'all' ? '' :
'<span class="ke-sec-chip">'+secFilter+' \u2605 \u00b7 '+items.length+
'<button type="button" data-clearfilter aria-label="'+esc(t.all)+'">\u00d7</button></span>';

var list = document.getElementById('ke-sec-list');
if (!secLoaded){ list.innerHTML = '<p class="ke-rev-status">'+t.loading+'</p>'; return; }
if (!items.length){

var magSvc = secFilter === 'all' && secTab === 'all' && !alles.length;
list.innerHTML = '<p class="ke-rev-status">'+(secFilter==='all'?t.nonePrd:t.none)+'</p>'+
(magSvc ? '<button type="button" class="ke-sec-svcbtn" id="ke-sec-svcbtn" data-ke-slideout-trigger="reviews">'+
esc(st.aanbod)+'</button>' : '');
leegKnoppen(); return;
}
items = sorteer(items);

toonReeks(list, items, sectionCard);
}

function toonService(){
var knop = document.getElementById('ke-sec-svcbtn');
if (knop) { knop.disabled = true; knop.textContent = t.loading; }
if (secSvcItems) { secSvcMode = true; return renderSection(); }

var p = ke.svc ? ke.svc() : Promise.resolve(null);
p.then(function(data){
secSvcItems = (data && data.items) || [];

if (data && data.votes) secSvcVotes = data.votes;
secSvcById = {};
for (var i = 0; i < secSvcItems.length; i++) secSvcById[secSvcItems[i].id] = secSvcItems[i];
secSvcMode = true;
secSvcFilter = 'all';
renderSection();
})["catch"](function(){
if (knop) { knop.disabled = false; knop.textContent = st.aanbod; }
});
}

var STAPPEN = [2, 4, 20];
var secLijst = [], secKaartFn = null, secGetoond = 0, secStap = 0;
function toonReeks(lijstEl, items, kaartFn){
secLijst = items; secKaartFn = kaartFn; secGetoond = 0; secStap = 0;
lijstEl.innerHTML = '';
meerKaarten(false);
}
function meerBeschikbaar(){ return secGetoond < secLijst.length; }

function meerKaarten(nieuw){
if (!meerBeschikbaar() || !secKaartFn){ knoppenBij(); return false; }
var lijst = document.getElementById('ke-sec-list');
var stap = STAPPEN[Math.min(secStap, STAPPEN.length - 1)];
var extra = secLijst.slice(secGetoond, secGetoond + stap);
var eerste = lijst.children.length;
lijst.insertAdjacentHTML('beforeend', extra.map(function(r){
var html = secKaartFn(r);
return nieuw ? html.replace('class="ke-sec-card', 'class="ke-sec-card is-new') : html;
}).join(''));
secGetoond += extra.length; secStap++;
knoppenBij();
zetLeesMeer();
return eerste;
}
function minderKaarten(){
var lijst = document.getElementById('ke-sec-list');
while (lijst.children.length > STAPPEN[0]) lijst.removeChild(lijst.lastElementChild);
secGetoond = Math.min(STAPPEN[0], secLijst.length); secStap = 1;
knoppenBij();
zetLeesMeer();
if (secEl && secEl.scrollIntoView) secEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function knoppenBij(){
var meer = document.getElementById('ke-sec-more'), minder = document.getElementById('ke-sec-less');
var teller = document.getElementById('ke-sec-progress');
if (!meer || !minder || !teller) return;
meer.hidden = !meerBeschikbaar();
minder.hidden = secGetoond <= STAPPEN[0];

var totaal = (prd.partial && MO && secFilter === 'all' && secTab === 'all' && MO.count > secLijst.length) ? MO.count : secLijst.length;
teller.innerHTML = secLijst.length
? esc(st.toon).replace('{n}', '<b>' + secGetoond + '</b>').replace('{m}', totaal.toLocaleString(LANG))
: '';
}
function leegKnoppen(){ secLijst = []; secGetoond = 0; knoppenBij(); }

function sluitService(){
secSvcMode = false;
secSvcShown = SVC_PER_KEER;
renderSection();
}

function stemUI(r){
var v = stemmenVan(r), mijn = mijnStemmen[r.id];
return '<span class="ke-vote" data-votewrap>'+
'<span class="ke-vote-q">'+t.helpful+'</span>'+
'<button type="button" class="ke-vote-btn'+(mijn==="up"?" voted":"")+'" data-vote="up" data-id="'+esc(r.id)+
'" aria-pressed="'+(mijn==="up")+'" title="'+esc(mijn==="up"?t.helpfulUndo:t.helpfulYes)+
'" aria-label="'+esc(t.helpfulYes)+'">'+
thumbIcon(false)+'<span data-up>'+v.u+'</span></button>'+
'<button type="button" class="ke-vote-btn'+(mijn==="down"?" voted":"")+'" data-vote="down" data-id="'+esc(r.id)+
'" aria-pressed="'+(mijn==="down")+'" title="'+esc(mijn==="down"?t.helpfulUndo:t.helpfulNo)+
'" aria-label="'+esc(t.helpfulNo)+'">'+
thumbIcon(true)+'<span data-down>'+v.d+'</span></button>'+
'</span>';
}

function serviceCard(r){
var datum = r.date ? timeAgo(r.date) : '';

var canTr = !!r.comment && taalVan(r) !== LANG;

var vink = ke.verifiedHtml ? ke.verifiedHtml() : '';
return '<article class="ke-sec-card ke-sec-card--svc" data-svc="1" data-id="'+esc(r.id)+'">'+
'<header class="ke-sec-card-head">'+
'<span class="ke-sec-card-left">'+srcMark('ts')+
stars(r.rating,'ke-rev-stars ke-rev-stars--sm')+'</span>'+
vink+
'</header>'+
(r.title ? '<h4 class="ke-sec-card-title">'+esc(r.title)+'</h4>' : '')+
'<p class="ke-sec-card-body" data-body>'+esc(r.comment || '')+'</p>'+
'<footer class="ke-sec-card-foot">'+
'<span class="ke-sec-date">'+esc(datum)+'</span>'+
(canTr ? '<button type="button" class="ke-rev-translate" data-tr="'+esc(r.id)+'">'+
t.translate+'</button>' : '')+
stemUI(r)+
'</footer>'+
'</article>';
}

function sectionCard(r){

var mark = srcMark(r.source);
var canTr = !!r.comment && taalVan(r) !== LANG;
var v = stemmenVan(r);
var mijn = mijnStemmen[r.id];

var rpOpen = !(r.comment && String(r.comment).trim());

var rpKnop = (r.reply && r.reply.c)
? '<button type="button" class="ke-sec-replybtn" data-rp="1">'+esc(rpOpen ? t.hideReply : t.seeReply)+'</button>' : '';
var rpBlok = (r.reply && r.reply.c)
? '<div'+(rpOpen ? '' : ' hidden')+(rpOpen ? ' data-rpauto="1"' : '')+'>'+replyHtml(r)+'</div>' : '';
var fh = fotoHtml(r);

var leeg = !(r.comment && String(r.comment).trim()) && !(r.title && String(r.title).trim());

return '<article class="ke-sec-card'+(leeg ? ' ke-sec-card--leeg' : '')+'" data-id="'+esc(r.id)+'"'+(r.translated ? ' data-translated="1"' : '')+'>'+
'<header class="ke-sec-card-head">'+
'<span class="ke-sec-card-left">'+mark+stars(r.rating,'ke-rev-stars ke-rev-stars--sm')+'</span>'+
'</header>'+
(secToonConditie
? '<span class="ke-sec-used'+(r.conditie === 'used' ? '' : ' is-new')+'">'+
esc(r.conditie === 'used' ? t.boughtUsed : t.boughtNew)+'</span>'
: '')+

'<div class="ke-sec-mid">'+
(r.title ? '<h4 class="ke-sec-card-title">'+esc(r.title)+'</h4>' : '')+
'<p class="ke-rev-comment" data-body>'+esc(r.comment)+'</p>'+
fh+
rpKnop+
rpBlok+
metricBars(r.custom_fields, 'ke-metrics ke-metrics--card')+
'</div>'+
byLine(r)+
'<footer class="ke-sec-card-foot">'+
'<span class="ke-sec-date">'+timeAgo(r.date)+'</span>'+
(canTr ? '<button type="button" class="ke-rev-translate" data-tr="'+esc(r.id)+'">'+(r.translated ? t.showOriginal : t.translate)+'</button>' : '')+
stemUI(r)+
'</footer>'+
'</article>';
}

function thumbIcon(omlaag){
return '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"'+
(omlaag ? ' style="transform:rotate(180deg)"' : '')+'>'+
'<path fill="currentColor" d="M2 10h4v11H2zM22 11a2 2 0 0 0-2-2h-5.6l.8-3.9c0-.2.1-.4.1-.6A1.5 1.5 0 0 0 13.8 3L8.6 8.2A2 2 0 0 0 8 9.6V19a2 2 0 0 0 2 2h8a2 2 0 0 0 1.8-1.2l2.1-4.9c.1-.2.1-.4.1-.6z"/>'+
'</svg>';
}

function onSectionClick(e){
var rp = e.target.closest('[data-rp]');
if (rp){
var kaartRp = rp.closest('.ke-sec-card');
var ant = kaartRp ? kaartRp.querySelector('.ke-rev-reply') : null;
ant = ant ? ant.parentElement : null;
if (ant){ ant.hidden = !ant.hidden; rp.textContent = ant.hidden ? t.seeReply : t.hideReply; }

if (kaartRp){
if (ant && !ant.hidden) kaartRp.classList.add('is-open');
else kaartRp.classList.remove('is-open');
var rmb = kaartRp.querySelector('[data-rm]');
if (rmb){
var o = kaartRp.classList.contains('is-open');
rmb.setAttribute('aria-expanded', o ? 'true' : 'false');
rmb.setAttribute('aria-label', o ? st.minder : st.meer);
}
}
zetLeesMeer();
return;
}

var rm = e.target.closest('[data-rm]');
if (rm){
var kaart = rm.closest('.ke-sec-card');
var open = kaart.classList.toggle('is-open');
rm.setAttribute('aria-expanded', open ? 'true' : 'false');
rm.setAttribute('aria-label', open ? st.minder : st.meer);
rmLabel(rm, open);

var rpk = kaart.querySelector('[data-rp]');
var antC = kaart.querySelector('.ke-rev-reply');
if (rpk && antC && antC.parentElement){
antC.parentElement.hidden = !open;
rpk.textContent = open ? t.hideReply : t.seeReply;
}
zetLeesMeer();
return;
}

if (e.target.closest('#ke-sec-svcterug')) return sluitService();
var sf = e.target.closest('[data-svcf]');
if (sf) {
secSvcFilter = sf.getAttribute('data-svcf');
return renderSection();
}
var stem = e.target.closest('[data-vote]');
if (stem) return opStem(stem);
var b = e.target.closest('[data-tr]');
if (!b) return;
var id = b.getAttribute('data-tr');
var card = b.closest('.ke-sec-card');
var body = card.querySelector('[data-body]');

var isSvc = card.dataset.svc === '1';
var rev = isSvc ? secSvcById[id] : prd.byId[id];
if (!rev) return;

var rp = card.querySelector('[data-reply]');
var ti = card.querySelector('.ke-sec-card-title');
function zet(tekst, antwoord, titel){
body.textContent = tekst;
if (rp) rp.textContent = antwoord || (rev.reply && rev.reply.c) || '';
if (ti && titel) ti.textContent = titel;
}

var origC = (rev.orig && rev.orig.comment) || rev.comment;
var origT = (rev.orig && rev.orig.title) || rev.title;
if (card.dataset.translated === '1'){
zet(origC, rev.reply && rev.reply.c, origT); card.dataset.translated = '0'; b.textContent = t.translate; return;
}
if (rev.translated && rev.orig){
zet(rev.comment, rev.reply && rev.reply.c, rev.title); card.dataset.translated = '1'; b.textContent = t.showOriginal; return;
}
if (transCache[id]){
zet(transCache[id].comment, transCache[id].reply); card.dataset.translated = '1'; b.textContent = t.showOriginal; return;
}
b.disabled = true; b.textContent = t.translating;
translateReview(id, !isSvc).then(function(res){
b.disabled = false;
if (!res || !res.ok){ b.textContent = t.translateFailed; return; }
transCache[id] = res;
zet(res.comment, res.reply);
card.dataset.translated = '1';
b.textContent = t.showOriginal;
});
}

function opStem(knop){
var id = knop.getAttribute('data-id');
var richting = knop.getAttribute('data-vote');
var wrap = knop.closest('[data-votewrap]');
var vorige = mijnStemmen[id] || 'none';
var nieuw = (vorige === richting) ? 'none' : richting;
if (vorige === nieuw) return;

var opUp = wrap.querySelector('[data-up]');
var opDown = wrap.querySelector('[data-down]');
var knopUp = wrap.querySelector('[data-vote="up"]');
var knopDown = wrap.querySelector('[data-vote="down"]');
var wasU = parseInt(opUp.textContent,10)||0;
var wasD = parseInt(opDown.textContent,10)||0;

var du = 0, dd = 0;
if (vorige === 'up') du--; else if (vorige === 'down') dd--;
if (nieuw === 'up') du++; else if (nieuw === 'down') dd++;

var toon = function(u, d, stand){
opUp.textContent = Math.max(0,u);
opDown.textContent = Math.max(0,d);
knopUp.classList.toggle('voted', stand === 'up');
knopDown.classList.toggle('voted', stand === 'down');
};
toon(wasU+du, wasD+dd, nieuw);

if (nieuw === 'none') delete mijnStemmen[id]; else mijnStemmen[id] = nieuw;
bewaarStemmen();

var pot = secSvcMode ? secSvcVotes : (prd.votes = prd.votes || {});
var lok = pot[id] || (pot[id] = { u: 0, d: 0 });
lok.u += du; lok.d += dd;

var u = PROXY_BASE + '?action=vote&id=' + encodeURIComponent(id) +
'&sku=' + encodeURIComponent(secSvcMode ? SVC_VOTE_KEY : SKU_FOR_VOTES) +
'&voter=' + encodeURIComponent(stemToken()) +
'&from=' + vorige + '&to=' + nieuw;
fetch(u, { method: 'POST' }).then(function(res){ return res.json(); }).then(function(d){
if (!d || !d.ok) throw new Error('mislukt');

var stand = d.naar || nieuw;
if (stand === 'none') delete mijnStemmen[id]; else mijnStemmen[id] = stand;
bewaarStemmen();
if (d.votes){
pot[id] = { u: d.votes.u || 0, d: d.votes.d || 0 };
toon(pot[id].u, pot[id].d, stand === 'none' ? null : stand);
}
}).catch(function(){
toon(wasU, wasD, vorige === 'none' ? null : vorige);
lok.u -= du; lok.d -= dd;
if (vorige === 'none') delete mijnStemmen[id]; else mijnStemmen[id] = vorige;
bewaarStemmen();
wrap.classList.add('ke-vote-fout');
setTimeout(function(){ wrap.classList.remove('ke-vote-fout'); }, 2000);
});
}

function observeSection(){
if (!mountSection()) return;
renderSection();
hideYotpoMain();

var pogingen = 0;
var iv = setInterval(function(){
hideYotpoMain();
if (++pogingen > 12) clearInterval(iv);
}, 700);

var start = function(){
if (secLoaded) return;
secLoaded = true;
toonSkeletten();

if (ke.loadProductFirst) ke.loadProductFirst().then(function(){ if (!prd.fullLoaded && prd.items.length) renderSection(); })["catch"](function(){});
loadProductFull().then(function(){ var was = secGetoond; renderSection(); while (secGetoond < was && meerBeschikbaar()) meerKaarten(false); });
};

var idle = window.requestIdleCallback || function(f){ return setTimeout(f, 800); };
idle(function(){ start(); }, { timeout: 2000 });
if ('IntersectionObserver' in window){
var io = new IntersectionObserver(function(en){
if (en[0] && en[0].isIntersecting){ io.disconnect(); start(); }
}, { rootMargin: '1400px' });
io.observe(secEl);
}
}

function maakRm(){
var b = document.createElement('button');
b.type = 'button'; b.className = 'ke-sec-rm'; b.setAttribute('data-rm','1'); b.hidden = true;
b.setAttribute('aria-expanded','false'); b.setAttribute('aria-label', st.meer);
b.innerHTML = '<span class="ke-sec-rm-t">'+esc(st.meer)+'\u2026</span>'+
'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">'+
'<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
return b;
}
function hoogteMet(el){
var cs = getComputedStyle(el);
return el.getBoundingClientRect().height + (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
}
function zetLeesMeer(){

var lijst0 = document.getElementById('ke-sec-list');
if (lijst0) fotoKijk(lijst0);
requestAnimationFrame(function(){
var lijst = document.getElementById('ke-sec-list');
if (!lijst) return;
var kaarten = lijst.querySelectorAll('.ke-sec-card:not(.ke-sec-skel)');
for (var i = 0; i < kaarten.length; i++){
var k = kaarten[i], body = k.querySelector('[data-body]');
if (!body) continue;
var b = k.querySelector('[data-rm]');
if (!b){ b = maakRm(); body.insertAdjacentElement('afterend', b); }
if (k.classList.contains('is-open')) continue;
var rc = k.querySelector('[data-rpauto] [data-reply]');
var mid = body.parentElement;
var vast = mid && mid.classList.contains('ke-sec-mid') && parseFloat(getComputedStyle(k).minHeight) > 0;
if (!vast){
body.style.removeProperty('--ke-lines');
b.hidden = !(body.scrollHeight > body.clientHeight + 2 || (rc && rc.scrollHeight > rc.clientHeight + 2));
k.classList.toggle('heeft-rm', !b.hidden);
continue;
}
body.style.setProperty('--ke-lines', 1); b.hidden = true;
var lh = parseFloat(getComputedStyle(body).lineHeight) || 21;
var overig = 0;
for (var c = 0; c < mid.children.length; c++){
var kind = mid.children[c];
if (kind !== body && kind !== b) overig += hoogteMet(kind);
}
var vrij = mid.clientHeight - overig;
body.style.setProperty('--ke-lines', Math.max(1, Math.floor(vrij / lh)));
if (body.scrollHeight > body.clientHeight + 1 || (rc && rc.scrollHeight > rc.clientHeight + 2)){
b.hidden = false;
body.style.setProperty('--ke-lines', Math.max(1, Math.floor((vrij - hoogteMet(b)) / lh)));
}
k.classList.toggle('heeft-rm', !b.hidden);
}
});
}
function rmLabel(b, open){
var lt = b.querySelector('.ke-sec-rm-t');
if (lt) lt.textContent = open ? st.minder : (st.meer + '\u2026');
}

function klapKaartIn(kaart){
kaart.classList.remove('is-open');
var b = kaart.querySelector('[data-rm]');
if (b){ b.setAttribute('aria-expanded','false'); b.setAttribute('aria-label', st.meer); rmLabel(b, false); }

var rp = kaart.querySelector('[data-rp]');
var ant = rp ? rp.nextElementSibling : null;
if (ant && !ant.hidden && !ant.hasAttribute('data-rpauto')){
ant.hidden = true; rp.textContent = t.seeReply;
}
}

function toonSkeletten(){
var lijst = document.getElementById('ke-sec-list');
if (!lijst || lijst.children.length) return;
var kaart = '<article class="ke-sec-card ke-sec-skel" aria-hidden="true">'+
'<div class="ke-skel-r" style="width:55%"></div>'+
'<div class="ke-skel-r" style="width:85%"></div>'+
'<div class="ke-skel-r" style="width:92%"></div>'+
'<div class="ke-skel-r" style="width:70%"></div>'+
'<div class="ke-skel-r ke-skel-r--foot" style="width:45%"></div>'+
'</article>';
lijst.innerHTML = kaart + kaart;
}

window.KEReviewsSection = { onData: function () { renderSection(); } };
observeSection();
});
})();
} catch (e) { console.error('KE Reviews sectie:', e); }
/* qa (12-qa-pdp.liquid) */
if (__KE_C["qa"]) try {
(function(){
"use strict";
var sec = document.getElementById("keqa");
if (!sec || sec.getAttribute("data-keqa-klaar")) return;
sec.setAttribute("data-keqa-klaar", "1");

if (sec.parentElement && sec.parentElement.classList.contains("custom-liquid-block")){ sec.parentElement.style.flex = "1 1 100%"; sec.parentElement.style.width = "100%"; sec.parentElement.style.minWidth = "0"; }

var PID = sec.getAttribute("data-keqa-pid") || "";
var LANG = sec.getAttribute("data-keqa-lang") || "en";

var APPKEY = "w5KTvQaIeKraoTNJmVzvqoKupB0cQNe9a98kSnfA";
var YOTPO = "https://api-cdn.yotpo.com";
var PROXY = "https://ke-reviews-proxy.marketing-bff.workers.dev";

var REVIEW_SOURCE = "widget_v3";
var STEMSLEUTEL = "qa-" + PID;
var PER_PAGE = 100, EERST = 3, STAP = 3;

var KE_NAMEN = ["Fabian G."];
var LOCALE = { nl: "nl-NL", en: "en-GB", de: "de-DE", fr: "fr-FR", es: "es-ES", it: "it-IT" }[LANG] || "en-GB";
var T = {
vraag: __KE_C["qa"].k0, antwoord: __KE_C["qa"].k1, gevraagd: __KE_C["qa"].k2, anoniem: __KE_C["qa"].k3,
nuttig: __KE_C["qa"].k4, nuttigJa: __KE_C["qa"].k5, nuttigUndo: __KE_C["qa"].k6,
antwoordKe: __KE_C["qa"].k7, antwoordVan: __KE_C["qa"].k8, wacht: __KE_C["qa"].k9,
origineel: __KE_C["qa"].k10, vertaald: __KE_C["qa"].k11, toonOrig: __KE_C["qa"].k12, toonVert: __KE_C["qa"].k13, sub1: __KE_C["qa"].k14, subN: __KE_C["qa"].k15,
formBezig: __KE_C["qa"].k16, formFout: __KE_C["qa"].k17
};
var PRODUCT = { title: __KE_C["qa"].k18, url: __KE_C["qa"].k19, img: __KE_C["qa"].k20, desc: __KE_C["qa"].k21 };
if (PRODUCT.img && PRODUCT.img.indexOf("//") === 0) PRODUCT.img = "https:" + PRODUCT.img;

function esc(s){ return String(s == null ? "" : s).replace(/[&<>"']/g, function(c){ return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

function normaliseer(d){
var r = (d && d.response) || {};
var lijst = r.questions || [];
var uit = [];
for (var i = 0; i < lijst.length; i++){
var q = lijst[i] || {};
var ans = q.answers || q.sorted_public_answers || [];
var antwoorden = [], basis = 0;
for (var j = 0; j < ans.length; j++){
var a = ans[j] || {};
if (!a.content) continue;
basis += Math.max(0, parseInt(a.votes_up, 10) || 0);
antwoorden.push({ id: String(a.id), tekst: String(a.content), datum: String(a.created_at || ""),
ke: !!(a.store_owner_comment || a["is_store_owner_comment?"]),
naam: String((a.answerer && a.answerer.display_name) || "") });
}
if (!q.content || !antwoorden.length) continue;
uit.push({ id: "q-" + q.id, tekst: String(q.content), datum: String(q.created_at || ""),
naam: String((q.asker && q.asker.display_name) || ""), antwoorden: antwoorden, basis: basis });
}
return uit;
}

function likesVan(q, votes){ var v = (votes || {})[q.id] || {}; return q.basis + Math.max(0, parseInt(v.u, 10) || 0); }
function sorteer(lijst, hoe, votes){
var k = lijst.slice();
k.sort(function(a, b){
if (hoe === "like"){ var d = likesVan(b, votes) - likesVan(a, votes); if (d) return d; }
return String(b.datum).localeCompare(String(a.datum)) || String(b.id).localeCompare(String(a.id));
});
return k;
}

function fmtDatum(iso){
var d = new Date(iso);
if (!iso || isNaN(d.getTime())) return "";
function p(n){ return (n < 10 ? "0" : "") + n; }
return p(d.getUTCDate()) + "-" + p(d.getUTCMonth() + 1) + "-" + d.getUTCFullYear();
}
function geldigEmail(s){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(s || "").trim()); }

var STOP = {
nl: "de het een en van is dat niet met op voor ook deze hoe welke wordt kan ik je zijn",
en: "the and is of to with for this that it you can which does are what how",
de: "der die das und ist nicht mit für auf ein eine wie kann welche wird dieser ich sie",
fr: "le les et est pas pour avec une des que qui dans sur quelle",
es: "el los las y es no para con una del que por puede este",
it: "il le e è non per con una del che di come può questo"
};
var STOPSETS = {};
for (var sl in STOP){ STOPSETS[sl] = {}; STOP[sl].split(" ").forEach(function(w){ STOPSETS[sl][w] = 1; }); }
function taalGok(tekst){
var w = String(tekst || "").toLowerCase().replace(/[^a-zà-ÿ\s-]/g, " ").split(/\s+/);
var best = null, bestN = 0, tweede = 0;
for (var l in STOPSETS){
var n = 0;
for (var i = 0; i < w.length; i++) if (STOPSETS[l][w[i]]) n++;
if (n > bestN){ tweede = bestN; bestN = n; best = l; } else if (n > tweede) tweede = n;
}
return bestN >= 2 && bestN > tweede ? best : null;
}

var TAALCODES = __KE_C["qa"].k22, TAALNAMEN = __KE_C["qa"].k23;
function taalNaam(code){
var ti = TAALCODES.indexOf(code);
if (ti !== -1 && TAALNAMEN[ti]) return TAALNAMEN[ti];
try { var s = new Intl.DisplayNames([LOCALE], { type: "language" }).of(code); return s || code; } catch (e) { return code; }
}

var ALLES = [], EIGEN = [], votes = {}, mijn = {}, sortHoe = "like", getoond = EERST;
var VERT = {}, ORIG = {};
var MOVERT = {}, MOSRC = {};
try { mijn = JSON.parse(localStorage.getItem("ke-votes-" + STEMSLEUTEL) || "{}") || {}; } catch (e) {}
try { EIGEN = JSON.parse(sessionStorage.getItem("keqa-eigen-" + PID) || "[]") || []; } catch (e) {}
function bewaar(){ try { localStorage.setItem("ke-votes-" + STEMSLEUTEL, JSON.stringify(mijn)); } catch (e) {} }
function bewaarEigen(){ try { sessionStorage.setItem("keqa-eigen-" + PID, JSON.stringify(EIGEN)); } catch (e) {} }

function stemToken(){
try {
var tk = localStorage.getItem("ke-rev-voter");
if (!tk){ var a = new Uint8Array(16); (window.crypto || window.msCrypto).getRandomValues(a); tk = ""; for (var i = 0; i < 16; i++) tk += ("0" + a[i].toString(16)).slice(-2); localStorage.setItem("ke-rev-voter", tk); }
return tk;
} catch (e) { return ""; }
}

var lijstEl = sec.querySelector("[data-keqa-lijst]"), leegEl = sec.querySelector("[data-keqa-leeg]"), subEl = sec.querySelector("[data-keqa-sub]"),
balkEl = sec.querySelector("[data-keqa-balk]"), sortEl = sec.querySelector("[data-keqa-sort]"), pagingEl = sec.querySelector("[data-keqa-paging]"),
meerEl = sec.querySelector("[data-keqa-meer]"), minderEl = sec.querySelector("[data-keqa-minder]"), foutEl = sec.querySelector("[data-keqa-fout]");

function ico(naam, maat){ return '<svg class="keqa-ico" width="' + maat + '" height="' + maat + '" aria-hidden="true"><use href="#keqa-' + naam + '"/></svg>'; }

function kaart(q, verborgen){
var n = likesVan(q, votes), aan = mijn[q.id] === "up";

var vr = VERT[q.id.slice(2)] || MOVERT[q.id.slice(2)], v = (vr && (!ORIG[q.id] || q.mo)) ? vr : null;
var h = '<article class="keqa-item" data-keqa-item="' + esc(q.id) + '"' + (verborgen ? ' hidden' : '') + '>';
h += '<div class="keqa-item__kop"><h3 class="keqa-item__vraag"><span class="keqa-sr">' + esc(T.vraag) + ': </span>' + esc(v ? v.q : q.tekst) + '</h3>' +
'<span class="keqa-item__meta">' + (q.naam ? esc(T.gevraagd) + ' ' + esc(KE_NAMEN.indexOf(q.naam) !== -1 ? T.anoniem : q.naam) + ' | ' : '') + esc(fmtDatum(q.datum)) + '</span></div>';
h += '<div class="keqa-item__acties"><button type="button" class="keqa-like' + (aan ? ' is-aan' : '') + '" data-keqa-like="' + esc(q.id) + '" aria-pressed="' + (aan ? 'true' : 'false') + '" title="' + esc(aan ? T.nuttigUndo : T.nuttigJa) + '">' +
ico("duim", 18) + '<span>' + esc(T.nuttig) + ' (<b data-keqa-n>' + n + '</b>)</span></button></div>';
for (var i = 0; i < q.antwoorden.length; i++){
var a = q.antwoorden[i];
var ke = a.ke || KE_NAMEN.indexOf(a.naam) !== -1;
var kop = ke ? esc(T.antwoordKe) : (a.naam ? esc(T.antwoordVan) + ' ' + esc(a.naam) : esc(T.antwoord));
h += '<div class="keqa-item__antwoord"><div class="keqa-item__antwoord-kop">' + ico("check", 16) + '<span>' + kop + '</span></div>' +
'<p class="keqa-item__antwoord-tekst"><span class="keqa-sr">' + esc(T.antwoord) + ': </span>' + esc(v && v.a[a.id] != null ? v.a[a.id] : a.tekst) + '</p></div>';
}

var gok = MOSRC.hasOwnProperty(q.id) ? MOSRC[q.id] : taalGok(q.tekst + " " + q.antwoorden.map(function(x){ return x.tekst; }).join(" "));
if (vr){
h += '<div class="keqa-item__taal">' + ico("globe", 14) + '<span>' + esc((v ? T.vertaald : T.origineel).replace("{taal}", taalNaam(vr.s))) + '</span>' +
'<button type="button" class="keqa-link" data-keqa-orig="' + esc(q.id) + '">' + esc(v ? T.toonOrig : T.toonVert) + '</button></div>';
} else if (gok && gok !== LANG) h += '<div class="keqa-item__taal">' + ico("globe", 14) + '<span>' + esc(T.origineel.replace("{taal}", taalNaam(gok))) + '</span></div>';
return h + '</article>';
}

function kaartEigen(e){
return '<article class="keqa-item is-wacht"><div class="keqa-item__kop"><h3 class="keqa-item__vraag"><span class="keqa-sr">' + esc(T.vraag) + ': </span>' + esc(e.q) + '</h3>' +
'<span class="keqa-item__meta">' + esc(T.gevraagd) + ' ' + esc(e.naam) + ' | ' + esc(e.datum) + '</span></div>' +
'<div class="keqa-item__wacht">' + ico("klok", 16) + '<span>' + esc(T.wacht) + '</span></div></article>';
}
function render(){
var lijst = sorteer(ALLES, sortHoe, votes), n = lijst.length;
lijstEl.innerHTML = EIGEN.map(kaartEigen).join("") + lijst.map(function(q, i){ return kaart(q, i >= getoond); }).join("");
subEl.textContent = n ? (n === 1 ? T.sub1 : T.subN.replace("{n}", String(n))) : "";
subEl.hidden = !n;
balkEl.hidden = n < 2;
leegEl.hidden = n > 0 || EIGEN.length > 0;
meerEl.hidden = n <= getoond;
minderEl.hidden = getoond <= EERST;
pagingEl.hidden = meerEl.hidden && minderEl.hidden;
}

try {
var moEl = document.getElementById("keqa-mo");
ALLES = (moEl ? JSON.parse(moEl.textContent) : []).map(function(x){
MOSRC["q-" + x.id] = x.s;
votes["q-" + x.id] = { u: x.v || 0, d: 0 };
if (x.t){ var va = {}; x.a.forEach(function(a){ va[a.id] = a.c; }); MOVERT[x.id] = { s: x.s, q: x.q, a: va }; }
return { id: "q-" + x.id, tekst: x.q, datum: x.d, naam: x.n, basis: x.b || 0, mo: !!x.t,
antwoorden: x.a.map(function(a){ return { id: a.id, tekst: a.c, ke: !!a.k, naam: a.n }; }) };
});
} catch (e) { ALLES = []; }
if (ALLES.length) render();

var geladen = false;
function laad(){
if (geladen) return;
geladen = true;

function vertalingen(){
return fetch(PROXY + "?action=qa&pid=" + encodeURIComponent(PID) + "&lang=" + encodeURIComponent(LANG)).then(function(r){ return r.json(); })
.then(function(t){ if (t && t.vertaald) VERT = t.vertaald; }).catch(function(){});
}

var vooraf = ALLES.length ? vertalingen() : null;
fetch(YOTPO + "/v1/widget/" + APPKEY + "/products/" + encodeURIComponent(PID) + "/questions?page=1&per_page=" + PER_PAGE)
.then(function(r){ if (!r.ok) throw new Error("http " + r.status); return r.json(); })
.then(function(d){
var nieuw = normaliseer(d);
return (vooraf || Promise.resolve()).then(function(){
ALLES = nieuw;
render();
if (!ALLES.length) return;
if (!vooraf) vertalingen().then(render);

return fetch(PROXY + "?action=votes&sku=" + encodeURIComponent(STEMSLEUTEL)).then(function(r){ return r.json(); })
.then(function(v){ if (v && v.votes){ votes = v.votes; render(); } }).catch(function(){});
});
})

.catch(function(){ render(); foutEl.hidden = ALLES.length > 0; });
}
if ("IntersectionObserver" in window){
var io = new IntersectionObserver(function(es){ for (var i = 0; i < es.length; i++) if (es[i].isIntersecting){ io.disconnect(); laad(); } }, { rootMargin: "600px 0px" });
io.observe(sec);
setTimeout(laad, 4000);
} else setTimeout(laad, 1500);

function opLike(knop){
var id = knop.getAttribute("data-keqa-like"), q = null;
for (var i = 0; i < ALLES.length; i++) if (ALLES[i].id === id) q = ALLES[i];
if (!q || knop.disabled) return;
var vorige = mijn[id] === "up" ? "up" : "none", nieuw = vorige === "up" ? "none" : "up";
var telEl = knop.querySelector("[data-keqa-n]"), was = parseInt(telEl.textContent, 10) || 0;
function toon(n, aan){ telEl.textContent = Math.max(0, n); knop.classList.toggle("is-aan", aan); knop.setAttribute("aria-pressed", aan ? "true" : "false"); knop.title = aan ? T.nuttigUndo : T.nuttigJa; }
toon(was + (nieuw === "up" ? 1 : -1), nieuw === "up");
if (nieuw === "up") mijn[id] = "up"; else delete mijn[id];
bewaar();
knop.disabled = true;

fetch(PROXY + "?action=vote&id=" + encodeURIComponent(id) + "&sku=" + encodeURIComponent(STEMSLEUTEL) + "&voter=" + encodeURIComponent(stemToken()) + "&to=" + nieuw, { method: "POST" })
.then(function(r){ return r.json(); })
.then(function(d){
if (!d || !d.ok) throw new Error("mislukt");
var stand = d.naar || nieuw;
if (stand === "up") mijn[id] = "up"; else delete mijn[id];
bewaar();
if (d.votes){ votes[id] = d.votes; toon(likesVan(q, votes), stand === "up"); }
})
.catch(function(){ toon(was, vorige === "up"); if (vorige === "up") mijn[id] = "up"; else delete mijn[id]; bewaar(); })
.then(function(){ knop.disabled = false; });
}

var dlg = document.getElementById("keqa-dlg");
var form = dlg ? dlg.querySelector("[data-keqa-form]") : null;
var dank = dlg ? dlg.querySelector("[data-keqa-dank]") : null;
var melding = dlg ? dlg.querySelector("[data-keqa-melding]") : null;
var opener = null, bezig = false;
function toonFout(veld, aan){
var g = form.querySelector('[data-keqa-veld="' + veld + '"]');
if (!g) return;
g.classList.toggle("is-wrong", !!aan);
var f = g.querySelector("[data-keqa-fout-voor]"); if (f) f.hidden = !aan;
var inv = g.querySelector("textarea, input"); if (inv) inv.setAttribute("aria-invalid", aan ? "true" : "false");
}
function openDlg(knop){
if (!dlg) return;
opener = knop;
form.reset();
["vraag", "naam", "email"].forEach(function(v){ toonFout(v, false); });
melding.hidden = true; melding.textContent = "";
form.hidden = false; dank.hidden = true;
if (typeof dlg.showModal === "function"){ if (!dlg.open) dlg.showModal(); } else dlg.setAttribute("open", "");
var ta = form.querySelector("textarea"); if (ta) ta.focus();
}
function sluitDlg(){
if (!dlg) return;
if (typeof dlg.close === "function"){ if (dlg.open) dlg.close(); } else dlg.removeAttribute("open");
if (opener && opener.focus) opener.focus();
}
function verstuur(e){
e.preventDefault();
if (bezig) return;
var f = form.elements;
var naam = f.naam.value.trim(), email = f.email.value.trim(), vraag = f.vraag.value.trim(), hp = f.website.value;
var okV = vraag.length >= 10, okN = naam.length >= 2, okE = geldigEmail(email);
toonFout("vraag", !okV); toonFout("naam", !okN); toonFout("email", !okE);
if (!(okV && okN && okE)){ var eerste = form.querySelector(".is-wrong textarea, .is-wrong input"); if (eerste) eerste.focus(); return; }
function klaar(){
EIGEN.unshift({ q: vraag, naam: naam, datum: fmtDatum(new Date().toISOString()) });
bewaarEigen(); render();
form.hidden = true; dank.hidden = false;
}
if (hp){ klaar(); return; }
var knop = form.querySelector("[data-keqa-verstuur]"), lbl = knop.textContent;
bezig = true; knop.disabled = true; knop.textContent = T.formBezig; melding.hidden = true;
var body = new URLSearchParams();
[["review_content", vraag], ["display_name", naam], ["email", email], ["appkey", APPKEY], ["review_source", REVIEW_SOURCE], ["sku", PID],
["product_title", PRODUCT.title], ["product_description", PRODUCT.desc], ["product_url", PRODUCT.url], ["product_image_url", PRODUCT.img]]
.forEach(function(p){ body.append(p[0], p[1] == null ? "" : String(p[1])); });
fetch(YOTPO + "/questions/send_confirmation_mail", { method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: body.toString() })
.then(function(r){ return r.json().catch(function(){ return {}; }).then(function(d){ return { ok: r.ok, d: d }; }); })
.then(function(x){
var code = x.d && x.d.status && x.d.status.code;
if (!x.ok || (code && code !== 200)) throw new Error("yotpo " + (code || x.ok));
klaar();
})
.catch(function(){ melding.textContent = T.formFout; melding.hidden = false; })
.then(function(){ bezig = false; knop.disabled = false; knop.textContent = lbl; });
}

sec.addEventListener("click", function(e){
var like = e.target.closest("[data-keqa-like]"); if (like){ opLike(like); return; }

var wissel = e.target.closest("[data-keqa-orig]"); if (wissel){ var wid = wissel.getAttribute("data-keqa-orig"); ORIG[wid] = !ORIG[wid]; laad(); render(); return; }
var open = e.target.closest("[data-keqa-open]"); if (open){ openDlg(open); return; }
if (e.target.closest("[data-keqa-meer]")){ getoond += STAP; render(); return; }
if (e.target.closest("[data-keqa-minder]")){ getoond = Math.max(EERST, getoond - STAP); render(); }
});
if (sortEl) sortEl.addEventListener("change", function(){ sortHoe = sortEl.value === "nieuw" ? "nieuw" : "like"; getoond = EERST; render(); });
if (dlg){
dlg.addEventListener("click", function(e){ if (e.target === dlg || e.target.closest("[data-keqa-sluit]")) sluitDlg(); });
dlg.addEventListener("cancel", function(){ if (opener && opener.focus) opener.focus(); });
form.addEventListener("submit", verstuur);
form.addEventListener("input", function(e){ var g = e.target.closest("[data-keqa-veld]"); if (g) toonFout(g.getAttribute("data-keqa-veld"), false); });
}
})();
} catch (e) { console.error('KE Reviews qa:', e); }
/* usp-top (7.5-usp-kort.liquid) */
if (__KE_C["usp-top"]) try {
(function(){
var bron = document.getElementById('ke-topusp');
if (!bron) return;

function zet(){
var tracks = document.querySelectorAll('[class*="ai-usp"][class*="__track"]'), gedaan = false;
Array.prototype.forEach.call(tracks, function(tr){
var items = Array.prototype.filter.call(tr.children, function(c){ return /__item(\s|$)/.test(c.className); });
if (!items.length) return;
var echt = items[0];
var doelen = [echt].concat(items.filter(function(c){ return c !== echt && c.getAttribute('aria-hidden') === 'true'; }));
doelen.forEach(function(it){
var copy = it.querySelector('[class*="__copy"],[class*="__text"]');
if (!copy || copy.hasAttribute('data-ke-topusp')) return;
copy.innerHTML = bron.innerHTML;
copy.setAttribute('data-ke-topusp', bron.getAttribute('data-ke-usp-src') || '');

if (it.tagName !== 'A') {
it.setAttribute('data-ke-slideout-trigger', 'service');
it.style.cursor = 'pointer';
if (it.getAttribute('aria-hidden') !== 'true') it.setAttribute('tabindex', '0');
}
});
gedaan = true;
});
pasAlles();
return gedaan;
}

function past(copy){
var lab = copy.querySelector('[data-ke-label]');
if (!lab || !copy.offsetParent) return;
lab.style.display = '';
var lh = parseFloat(getComputedStyle(copy).lineHeight) || 22;
if (copy.getBoundingClientRect().height > lh * 1.5) lab.style.display = 'none';
}
function pasAlles(){ Array.prototype.forEach.call(document.querySelectorAll('[data-ke-topusp]'), past); }
var rt = null;
window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(pasAlles, 120); });
if (document.fonts && document.fonts.ready) document.fonts.ready.then(pasAlles);

var ontwerp = !!(window.Shopify && window.Shopify.designMode);
var mo = window.MutationObserver ? new MutationObserver(function(){ if (zet() && !ontwerp) mo.disconnect(); }) : null;
if ((!zet() || ontwerp) && mo) {
mo.observe(document.documentElement, { childList: true, subtree: true });
if (!ontwerp) setTimeout(function(){ mo.disconnect(); }, 15000);
}
document.addEventListener('DOMContentLoaded', zet);
document.addEventListener('shopify:section:load', function(){ setTimeout(zet, 0); });
})();
} catch (e) { console.error('KE Reviews usp-top:', e); }
/* band (8-home-reviews.liquid) */
if (__KE_C["band"]) try {
(function(){
"use strict";
var sec = document.getElementById("kehr");
if (!sec || sec.getAttribute("data-kehr-klaar")) return;
sec.setAttribute("data-kehr-klaar", "1");
if (sec.parentElement && sec.parentElement.classList.contains("custom-liquid-block")) sec.parentElement.classList.add("kehr-vol");

var PROXY = "https://ke-reviews-proxy.marketing-bff.workers.dev/";
var COUNTRY = (sec.getAttribute("data-kehr-country") || "NL").toUpperCase();
var LANG = (sec.getAttribute("data-kehr-lang") || "nl").toLowerCase();
var MAX_KAARTEN = 12;
var MAX_VERTAAL = 8;
var MIN_KAARTEN = 3;
var MAX_RESERVE = 16;
var SNELHEID = 20;

var T = {
nl:{ meer:"Lees meer", geen:"Geen beoordelingen", title:"Beoordelingen", subSvc:"Beoordelingen over onze service en winkel", tabSvc:"Service & winkel", all:"Alle", none:"Geen reviews met deze filter.", reviews:"beoordelingen", verifiedBuyer:"Geverifieerde koper", translate:"Vertalen", showOriginal:"Toon origineel", translatedFrom:"Vertaald uit het", translating:"Vertalen…", translateFailed:"Vertaling niet beschikbaar", sortHelpful:"Populairst", helpful:"Was dit nuttig?", helpfulYes:"Ja, nuttig", helpfulNo:"Niet nuttig", helpfulUndo:"Stem intrekken", lab:["Matig","Redelijk","Goed","Zeer goed","Uitstekend"] },
en:{ meer:"Read more", geen:"No reviews", title:"Reviews", subSvc:"Reviews about our service and store", tabSvc:"Service & store", all:"All", none:"No reviews with this filter.", reviews:"reviews", verifiedBuyer:"Verified buyer", translate:"Translate", showOriginal:"Show original", translatedFrom:"Translated from", translating:"Translating…", translateFailed:"Translation unavailable", sortHelpful:"Most liked", helpful:"Was this helpful?", helpfulYes:"Yes, helpful", helpfulNo:"Not helpful", helpfulUndo:"Undo vote", lab:["Poor","Fair","Good","Very Good","Excellent"] },
de:{ meer:"Mehr lesen", geen:"Keine Bewertungen", title:"Bewertungen", subSvc:"Bewertungen über unseren Service und Shop", tabSvc:"Service & Shop", all:"Alle", none:"Keine Bewertungen mit diesem Filter.", reviews:"Bewertungen", verifiedBuyer:"Verifizierter Käufer", translate:"Übersetzen", showOriginal:"Original anzeigen", translatedFrom:"Übersetzt aus dem", translating:"Übersetzung…", translateFailed:"Übersetzung nicht verfügbar", sortHelpful:"Beliebteste", helpful:"War das hilfreich?", helpfulYes:"Ja, hilfreich", helpfulNo:"Nicht hilfreich", helpfulUndo:"Bewertung zurücknehmen", lab:["Mäßig","Befriedigend","Gut","Sehr gut","Ausgezeichnet"] },
fr:{ meer:"Lire la suite", geen:"Aucun avis", title:"Avis", subSvc:"Avis sur notre service et notre boutique", tabSvc:"Service & boutique", all:"Tous", none:"Aucun avis avec ce filtre.", reviews:"avis", verifiedBuyer:"Acheteur vérifié", translate:"Traduire", showOriginal:"Voir l'original", translatedFrom:"Traduit du", translating:"Traduction…", translateFailed:"Traduction indisponible", sortHelpful:"Les plus appréciés", helpful:"Cet avis vous a-t-il aidé ?", helpfulYes:"Oui, utile", helpfulNo:"Pas utile", helpfulUndo:"Annuler le vote", lab:["Insuffisant","Satisfaisant","Bon","Très bon","Excellent"] },
es:{ meer:"Leer más", geen:"Sin opiniones", title:"Reseñas", subSvc:"Reseñas sobre nuestro servicio y tienda", tabSvc:"Servicio y tienda", all:"Todas", none:"No hay reseñas con este filtro.", reviews:"reseñas", verifiedBuyer:"Comprador verificado", translate:"Traducir", showOriginal:"Ver original", translatedFrom:"Traducido del", translating:"Traduciendo…", translateFailed:"Traducción no disponible", sortHelpful:"Más populares", helpful:"¿Te ha resultado útil?", helpfulYes:"Sí, útil", helpfulNo:"No útil", helpfulUndo:"Retirar voto", lab:["Regular","Aceptable","Bueno","Muy bueno","Excelente"] },
it:{ meer:"Leggi tutto", geen:"Nessuna recensione", title:"Recensioni", subSvc:"Recensioni sul nostro servizio e negozio", tabSvc:"Servizio e negozio", all:"Tutte", none:"Nessuna recensione con questo filtro.", reviews:"recensioni", verifiedBuyer:"Acquirente verificato", translate:"Traduci", showOriginal:"Mostra originale", translatedFrom:"Tradotto dal", translating:"Traduzione…", translateFailed:"Traduzione non disponibile", sortHelpful:"Più apprezzate", helpful:"È stato utile?", helpfulYes:"Sì, utile", helpfulNo:"Non utile", helpfulUndo:"Annulla voto", lab:["Mediocre","Discreto","Buono","Molto buono","Eccellente"] }
};
var t = T[LANG] || T.en;

var VOOR = { de:"", nl:"", fr:"Évalué comme ", es:"Valorado como ", it:"Valutato ", en:"Rated " };
var ACHTER = { de:" bewertet", nl:" beoordeeld", fr:"", es:"", it:"", en:"" };
var NA = { de:" basierend auf ", nl:" op basis van ", fr:" sur la base de ", es:" según ", it:" sulla base di ", en:" based on " };
var EIND = { de:" Kundenbewertungen", nl:" klantreviews", fr:" avis clients", es:" opiniones de clientes", it:" recensioni dei clienti", en:" customer reviews" };

var TW = { en:"the and was very with this for that have not are my", de:"und der die das ist nicht mit sehr ich wurde auch wir ein eine was",
nl:"het een niet ik met zeer goed snel werd ook maar van was", fr:"les et très pas est une je livraison des pour",
es:"muy que con los las para pero también", it:"molto che con di non sono anche per della" };
var TWS = {}; for (var k in TW) TWS[k] = " " + TW[k] + " ";
function taal(txt){
var w = String(txt || "").toLowerCase().replace(/[^a-zà-ÿ\s]/g, " ").split(/\s+/), sc = {}, best = null, hi = 0, gelijk = false;
for (var i = 0; i < w.length; i++){ if (!w[i]) continue; for (var l in TWS){ if (TWS[l].indexOf(" " + w[i] + " ") !== -1) sc[l] = (sc[l] || 0) + 1; } }
for (var l2 in sc){ if (sc[l2] > hi){ hi = sc[l2]; best = l2; gelijk = false; } else if (sc[l2] === hi) gelijk = true; }
return hi >= 2 && !gelijk ? best : null;
}
function taalVan(r){ return taal((r.title || "") + " " + (r.comment || "")) || String(r.srcLang || "").toLowerCase().split(/[-_]/)[0]; }

function kies(items, lang, n, maxVertaal){
var ok = (items || []).filter(function(r){ return r && r.rating >= 4 && String(r.comment || "").trim().length >= 10; });
ok.sort(function(a, b){ return String(b.date).localeCompare(String(a.date)); });
var native = [], anders = [];
ok.forEach(function(r){
var d = taal((r.title || "") + " " + (r.comment || ""));
var src = String(r.srcLang || "").toLowerCase().split(/[-_]/)[0];
if (d === lang || (d === null && src === lang)) native.push(r); else anders.push(r);
});
native = native.slice(0, n);
var vertaal = anders.slice(0, Math.max(0, Math.min(maxVertaal, n - native.length)));

return { native: native, vertaal: vertaal, rest: anders.slice(vertaal.length) };
}
if (typeof window !== "undefined") window.KEHR_kies = kies;

function esc(s){ return String(s == null ? "" : s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }
function ster(pct){ return '<span style="--f:'+pct+'%"><svg aria-hidden="true"><use href="#kehr-star"/></svg><svg class="kehr-sv-f" aria-hidden="true"><use href="#kehr-star"/></svg></span>'; }
function sterren(rating, px, cls){
var r = Math.max(0, Math.min(5, Number(rating) || 0)), out = "";
for (var i = 0; i < 5; i++) out += ster(Math.round(Math.max(0, Math.min(1, r - i)) * 100));
return '<span class="'+(cls ? cls+' ' : '')+'kehr-sv" role="img" aria-label="'+(Math.round(r*100)/100)+' / 5"'+(px ? ' style="font-size:'+px+'px"' : '')+'>'+out+'</span>';
}
function sinds(iso){
if (!iso) return "";
var d = new Date(iso); if (isNaN(d.getTime())) return "";
var diff = Math.round((d.getTime() - Date.now()) / 1000), a = Math.abs(diff), rtf;
try { rtf = new Intl.RelativeTimeFormat(LANG, { numeric: "auto" }); } catch (e) { rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" }); }
if (a < 86400) return rtf.format(Math.round(diff / 3600), "hour");
if (a < 2592000) return rtf.format(Math.round(diff / 86400), "day");
if (a < 31536000) return rtf.format(Math.round(diff / 2592000), "month");
return rtf.format(Math.round(diff / 31536000), "year");
}
function fmtScore(n){ var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < .005 ? String(Math.round(r)) : r.toLocaleString(LANG, { maximumFractionDigits: 2 }); }
function langName(code){ try { return new Intl.DisplayNames([LANG], { type: "language" }).of(code); } catch (e) { return String(code || "").toUpperCase(); } }
var VINK = '<svg width="15" height="15" fill="none" aria-hidden="true"><use href="#kehr-vink"/></svg>';
var VER = '<span class="kehr-ver">'+VINK+esc(t.verifiedBuyer)+'</span>';
var TS = '<span class="kehr-src" title="Trusted Shops">e</span>';

var band = sec.querySelector("[data-kehr-band]"), spoor = sec.querySelector("[data-kehr-spoor]");
var CITATEN = [];
var ALLES = [];
var VERTAALD = {};

function inhoud(q){
return '<span class="kehr-kaart__top">'+sterren(q.rating, 15)+
(q.vertaald ? '<span class="kehr-vert" title="'+esc(t.translatedFrom+' '+langName(q.src))+'">'+esc(t.translatedFrom+' '+langName(q.src))+'</span>' : '')+TS+'</span>'+
'<h4>'+esc(q.title || "")+'</h4><blockquote>'+esc(q.comment)+'</blockquote>'+
'<button type="button" class="kehr-meer" data-kehr-open="'+esc(q.id)+'">'+esc(t.meer)+
'<svg width="13" height="13" fill="none" aria-hidden="true"><use href="#kehr-chev"/></svg></button>'+
'<figcaption>'+VER+'<span class="kehr-datum">· '+esc(sinds(q.date))+'</span></figcaption>'+
'<button type="button" class="kehr-vlak" data-kehr-open="'+esc(q.id)+'" aria-label="'+esc(t.meer)+'"></button>';
}
function markeerMeer(kaart){
var b = kaart.querySelector("blockquote"), m = kaart.querySelector(".kehr-meer");
if (b && m) m.classList.toggle("aan", b.scrollHeight > b.clientHeight + 1);
}

var bandGestart = false, SMAL = window.matchMedia("(max-width: 749px)"), herbouw = null;
function smalRender(){
spoor.innerHTML = CITATEN.map(function(q){ return '<figure class="kehr-kaart">'+inhoud(q)+'</figure>'; }).join("");
Array.prototype.forEach.call(spoor.children, markeerMeer);
}
function startBand(){

if (bandGestart){ if (SMAL.matches) smalRender(); else if (herbouw) herbouw(); return; }
bandGestart = true;
if (SMAL.matches){
smalRender();
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ Array.prototype.forEach.call(spoor.children, markeerMeer); });
return;
}
var STIL_VOORKEUR = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
var kaarten = [], STAP = 340, RONDE = 0, W = 1, beurt = [], volgende = 0;
var offset = 0, doel = 0, raf = null, vorige = 0, inBeeld = false;

var WACHT = 3000, startNa = Infinity;
var pakt = false, gesleept = false, startX = 0, startOffset = 0, laatstX = 0, laatstT = 0, vX = 0;

var statisch = false;

function bouw(){
W = band.clientWidth || 1;
if (!kaarten.length) spoor.innerHTML = '<figure class="kehr-kaart">'+inhoud(CITATEN[0])+'</figure>';
var kb = spoor.firstElementChild.offsetWidth || 328;
STAP = kb + 12;
var nodig = Math.ceil(W / STAP) + 2;
statisch = CITATEN.length < nodig;
band.classList.toggle("kehr-stil", statisch);
if (statisch){ offset = doel = 0; }
var n = statisch ? CITATEN.length : nodig;
if (n !== kaarten.length){
spoor.innerHTML = CITATEN.slice(0, n).map(function(q){ return '<figure class="kehr-kaart">'+inhoud(q)+'</figure>'; }).join("");
kaarten = Array.prototype.slice.call(spoor.children);
}
RONDE = STAP * kaarten.length;
volgende = kaarten.length;
beurt = kaarten.map(function(_, i){ return Math.floor((i * STAP - offset) / RONDE); });
kaarten.forEach(markeerMeer);
}

var hover = false, focusBinnen = false, laatstGeplaatst = null;
function plaats(){
if (statisch){ for (var j = 0; j < kaarten.length; j++) kaarten[j].style.transform = "translate3d(" + (j * STAP) + "px,0,0)"; laatstGeplaatst = offset; return; }
var wissel = [];
for (var i = 0; i < kaarten.length; i++){
var s = i * STAP - offset, ronde = Math.floor(s / RONDE);
if (beurt[i] !== ronde){ beurt[i] = ronde; kaarten[i].innerHTML = inhoud(CITATEN[volgende++ % CITATEN.length]); wissel.push(kaarten[i]); }
var x = ((s % RONDE) + RONDE) % RONDE - STAP;
kaarten[i].style.transform = "translate3d(" + x.toFixed(2) + "px,0,0)";
}
if (wissel.length) requestAnimationFrame(function(){ wissel.forEach(markeerMeer); });
laatstGeplaatst = offset;
}
function loopt(){ return !statisch && !pakt && !STIL_VOORKEUR && !SMAL.matches && !hover && !focusBinnen; }
function lus(nu){
var dt = Math.min(.05, (nu - (vorige || nu)) / 1000); vorige = nu;
if (loopt() && nu >= startNa) doel += SNELHEID * dt;
if (!pakt) offset += (doel - offset) * Math.min(1, dt * 9);
if (laatstGeplaatst === null || Math.abs(offset - laatstGeplaatst) > 0.001) plaats();
raf = inBeeld ? requestAnimationFrame(lus) : null;
}
band.addEventListener("pointerenter", function(){ hover = true; });
band.addEventListener("focusin", function(e){ try { focusBinnen = !!(e.target && e.target.matches(":focus-visible")); } catch (err) { focusBinnen = true; } });
band.addEventListener("focusout", function(){ focusBinnen = false; });
band.addEventListener("pointerdown", function(e){
if (e.button !== 0 && e.pointerType === "mouse") return;
if (statisch || e.target.closest("[data-kehr-stap]")) return;
pakt = true; gesleept = false; startX = laatstX = e.clientX; startOffset = offset; laatstT = e.timeStamp; vX = 0;
band.classList.add("pak");
});
band.addEventListener("pointermove", function(e){
if (!pakt){
var r = band.getBoundingClientRect(), rel = (e.clientX - r.left) / r.width;
band.classList.toggle("hoek-l", rel < .18); band.classList.toggle("hoek-r", rel > .82);
return;
}
var dx = e.clientX - startX;
if (!gesleept && Math.abs(dx) > 5){ gesleept = true; try { band.setPointerCapture(e.pointerId); } catch (err) {} }
offset = doel = startOffset - dx;
var dt = e.timeStamp - laatstT;
if (dt > 8){ vX = (e.clientX - laatstX) / dt; laatstX = e.clientX; laatstT = e.timeStamp; }
plaats();
});
function los(){
if (!pakt) return;
pakt = false; band.classList.remove("pak");
doel = offset - Math.max(-900, Math.min(900, vX * 250));
if (!raf && inBeeld){ vorige = 0; raf = requestAnimationFrame(lus); }
}
band.addEventListener("pointerup", los);
band.addEventListener("pointercancel", los);
band.addEventListener("pointerleave", function(){ hover = false; band.classList.remove("hoek-l", "hoek-r"); });
band.addEventListener("click", function(e){ if (gesleept){ e.stopPropagation(); e.preventDefault(); gesleept = false; } }, true);
sec.querySelectorAll("[data-kehr-stap]").forEach(function(b){
b.addEventListener("click", function(){ doel += Number(b.getAttribute("data-kehr-stap")) * STAP; if (!raf && inBeeld){ vorige = 0; raf = requestAnimationFrame(lus); } });
});
bouw(); plaats();
herbouw = function(){ bouw(); plaats(); };
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ kaarten.forEach(markeerMeer); });
if (window.ResizeObserver) new ResizeObserver(function(){ bouw(); plaats(); }).observe(band);
if (window.IntersectionObserver){
new IntersectionObserver(function(rijen){
var r = rijen[0]; inBeeld = r.isIntersecting;
if (!inBeeld) startNa = Infinity;
else if (r.intersectionRatio >= .5 && startNa === Infinity) startNa = performance.now() + WACHT;
if (inBeeld && !raf){ vorige = 0; raf = requestAnimationFrame(lus); }
}, { threshold: [.05, .5] }).observe(band);
} else { inBeeld = true; startNa = performance.now() + WACHT; raf = requestAnimationFrame(lus); }
}

var so = document.getElementById("kehr-so");
if (so && so.parentElement !== document.body) document.body.appendChild(so);
var body = so.querySelector("[data-so-body]"), filters = so.querySelector("[data-so-filters]"), sortPil = so.querySelector("[data-so-sort]");
so.querySelector("[data-so-titel]").textContent = t.title;
so.querySelector("[data-so-sub]").textContent = t.subSvc;
so.querySelector("[data-so-tab]").textContent = t.tabSvc;
so.querySelector('.ke-rev-pill[data-filter="all"]').textContent = t.all;
sortPil.textContent = t.sortHelpful;
var activeFilter = "all", panelSort = "top", laatsteTrigger = null;
function zetFilter(f){ activeFilter = f; panelSort = f === "helpful" ? "helpful" : "top"; filters.querySelectorAll(".ke-rev-pill[data-filter]").forEach(function(q){ q.classList.toggle("active", q.getAttribute("data-filter") === f); }); sortPil.classList.toggle("active", f === "helpful"); }
body.addEventListener("scroll", function(){ body.parentElement.classList.toggle("ke-scrolled", body.scrollTop > 8 && SMAL.matches); }, { passive: true });

var STEMSLEUTEL = "svc-" + COUNTRY.toLowerCase();
var votes = {}, mijnStemmen = {};
try { mijnStemmen = JSON.parse(localStorage.getItem("ke-votes-" + STEMSLEUTEL) || "{}") || {}; } catch (e) {}
function bewaarStemmen(){ try { localStorage.setItem("ke-votes-" + STEMSLEUTEL, JSON.stringify(mijnStemmen)); } catch (e) {} }

function stemToken(){
try {
var tk = localStorage.getItem("ke-rev-voter");
if (!tk){ var a = new Uint8Array(16); (window.crypto || window.msCrypto).getRandomValues(a); tk = ""; for (var i = 0; i < 16; i++) tk += ("0" + a[i].toString(16)).slice(-2); localStorage.setItem("ke-rev-voter", tk); }
return tk;
} catch (e) { return ""; }
}
function stemmenVan(r){ var v = votes[r.id] || {}; return { u: Math.max(0, v.u || 0), d: Math.max(0, v.d || 0) }; }
function duim(neer){ return '<svg class="ke-vote-ico'+(neer ? ' ke-vote-ico--neer' : '')+'" width="15" height="15" aria-hidden="true"><use href="#kehr-duim"/></svg>'; }
function stemUI(r){
var v = stemmenVan(r), mijn = mijnStemmen[r.id];
return '<span class="ke-vote" data-votewrap>'+
'<span class="ke-vote-q">'+esc(t.helpful)+'</span>'+
'<button type="button" class="ke-vote-btn'+(mijn==='up'?' voted':'')+'" data-vote="up" data-id="'+esc(r.id)+'" aria-pressed="'+(mijn==='up')+'" title="'+esc(mijn==='up'?t.helpfulUndo:t.helpfulYes)+'" aria-label="'+esc(t.helpfulYes)+'">'+duim(false)+'<span data-up>'+v.u+'</span></button>'+
'<button type="button" class="ke-vote-btn'+(mijn==='down'?' voted':'')+'" data-vote="down" data-id="'+esc(r.id)+'" aria-pressed="'+(mijn==='down')+'" title="'+esc(mijn==='down'?t.helpfulUndo:t.helpfulNo)+'" aria-label="'+esc(t.helpfulNo)+'">'+duim(true)+'<span data-down>'+v.d+'</span></button>'+
'</span>';
}
function stemVerschil(van, naar){
if (van === naar) return null;
var du = 0, dd = 0;
if (van === "up") du--; else if (van === "down") dd--;
if (naar === "up") du++; else if (naar === "down") dd++;
return { du: du, dd: dd };
}
function opStem(knop){
var id = knop.getAttribute("data-id"), richting = knop.getAttribute("data-vote"), wrap = knop.closest("[data-votewrap]");
var vorige = mijnStemmen[id] || "none", nieuw = vorige === richting ? "none" : richting, v = stemVerschil(vorige, nieuw);
if (!v) return;
var opUp = wrap.querySelector("[data-up]"), opDown = wrap.querySelector("[data-down]");
var wasU = parseInt(opUp.textContent, 10) || 0, wasD = parseInt(opDown.textContent, 10) || 0;
function toon(u, d, actief){
opUp.textContent = Math.max(0, u); opDown.textContent = Math.max(0, d);
var kn = wrap.querySelectorAll(".ke-vote-btn");
kn[0].classList.toggle("voted", actief === "up"); kn[1].classList.toggle("voted", actief === "down");
kn[0].setAttribute("aria-pressed", actief === "up"); kn[1].setAttribute("aria-pressed", actief === "down");
}
toon(wasU + v.du, wasD + v.dd, nieuw === "none" ? null : nieuw);
if (nieuw === "none") delete mijnStemmen[id]; else mijnStemmen[id] = nieuw;
bewaarStemmen();
fetch(PROXY + "?action=vote&id=" + encodeURIComponent(id) + "&sku=" + encodeURIComponent(STEMSLEUTEL) + "&voter=" + encodeURIComponent(stemToken()) + "&from=" + vorige + "&to=" + nieuw, { method: "POST" })
.then(function(res){ return res.json(); })
.then(function(d){
if (!d || !d.ok) throw new Error("mislukt");
var stand = d.naar || nieuw;
if (stand === "none") delete mijnStemmen[id]; else mijnStemmen[id] = stand; bewaarStemmen();
if (d.votes){ votes[id] = d.votes; toon(d.votes.u || 0, d.votes.d || 0, stand === "none" ? null : stand); }
})
.catch(function(){ toon(wasU, wasD, vorige === "none" ? null : vorige); if (vorige === "none") delete mijnStemmen[id]; else mijnStemmen[id] = vorige; bewaarStemmen(); });
}

function label(g){ return t.lab[Math.max(1, Math.min(5, Math.round(Number(g) || 0))) - 1]; }
function vulScore(g){
var el = so.querySelector("[data-so-score]");
if (!g || !g.rating){ el.style.display = "none"; return; }
so.querySelector("[data-so-num]").textContent = fmtScore(g.rating);
so.querySelector("[data-so-sterren]").innerHTML = sterren(g.rating, 0, "ke-rev-stars");
so.querySelector("[data-so-scoresub]").textContent = label(g.rating) + (g.count ? " · " + Number(g.count).toLocaleString(LANG) + " " + t.reviews : "");
el.style.display = "";
}
function render(){
var items = ALLES.slice();
if (activeFilter !== "all" && activeFilter !== "helpful"){ var f = parseInt(activeFilter, 10); items = items.filter(function(r){ return Math.round(r.rating) === f; }); }
if (!items.length){ body.innerHTML = '<p class="ke-rev-status">'+esc(t.none)+'</p>'; return; }
if (panelSort === "helpful"){
items.sort(function(a, b){ var va = stemmenVan(a), vb = stemmenVan(b); return (vb.u - vb.d) - (va.u - va.d) || String(b.date).localeCompare(String(a.date)); });
}

var hoog = function(r){ return Math.round(r.rating) >= 4; };
items = (activeFilter === "all" ? [items.filter(hoog), items.filter(function(r){ return !hoog(r); })] : [items]).reduce(function(u, g){ return u.concat(g.filter(function(r){ return taalVan(r) === LANG; }), g.filter(function(r){ return taalVan(r) !== LANG; })); }, []);
body.innerHTML = items.map(function(r){
var src = taalVan(r), canTr = !!r.comment && src !== LANG, tr = VERTAALD[r.id], showing = tr ? "trans" : "orig";
return '<div class="ke-rev-card" data-id="'+esc(r.id)+'" data-showing="'+showing+'">'+
'<div class="ke-rev-card-top"><span>'+sterren(r.rating, 0, "ke-rev-stars")+'</span><span class="ke-rev-verified">'+VINK+esc(t.verifiedBuyer)+'</span></div>'+
(r.title ? '<div class="ke-rev-card-title">'+esc(tr ? (tr.title || r.title) : r.title)+'</div>' : '')+
'<div class="ke-rev-comment">'+esc(tr ? tr.comment : r.comment)+'</div>'+
'<div class="ke-rev-meta">'+esc(sinds(r.date))+'</div>'+
'<div class="ke-rev-foot">'+
(canTr ? '<span class="ke-rev-tr"><button type="button" class="ke-rev-translate">'+esc(tr ? t.showOriginal : t.translate)+'</button><span class="ke-rev-tr-note">'+(tr ? esc(t.translatedFrom+" "+langName(src)) : "")+'</span></span>' : '')+
stemUI(r)+
'</div></div>';
}).join("");
}
function vertaalKaart(card, r){
var c = card.querySelector(".ke-rev-comment"), ti = card.querySelector(".ke-rev-card-title"), note = card.querySelector(".ke-rev-tr-note"), btn = card.querySelector(".ke-rev-translate");
if (card.getAttribute("data-showing") === "trans"){
c.textContent = r.comment; if (ti) ti.textContent = r.title; note.textContent = ""; btn.textContent = t.translate; card.setAttribute("data-showing", "orig"); return;
}
function zet(tr){ c.textContent = tr.comment; if (ti && tr.title) ti.textContent = tr.title; note.textContent = t.translatedFrom + " " + langName(taalVan(r)); btn.textContent = t.showOriginal; card.setAttribute("data-showing", "trans"); }
if (VERTAALD[r.id]){ zet(VERTAALD[r.id]); return; }
btn.textContent = t.translating; btn.disabled = true;
vertaal(r).then(function(x){
btn.disabled = false;
if (!x){ btn.textContent = t.translate; note.textContent = t.translateFailed; return; }
VERTAALD[r.id] = { comment: x.comment, title: x.title }; zet(VERTAALD[r.id]);
});
}
function openSo(trigger, id){
laatsteTrigger = trigger || null;
if (!body.children.length) render();
so.classList.add("open"); so.setAttribute("aria-hidden", "false");
document.documentElement.style.overflow = "hidden";
if (id){
if (activeFilter !== "all"){ zetFilter("all"); render(); }

var el = null, kaarten = body.querySelectorAll('.ke-rev-card[data-id]');
for (var ki = 0; ki < kaarten.length; ki++){ if (kaarten[ki].getAttribute("data-id") === id){ el = kaarten[ki]; break; } }
if (el){
body.scrollTop = Math.max(0, el.offsetTop - body.offsetTop - 12);
el.classList.add("kehr-aan"); setTimeout(function(){ el.classList.remove("kehr-aan"); }, 2400);
}
} else body.scrollTop = 0;
so.querySelector(".ke-rev-close").focus();
}
function sluitSo(){
so.classList.remove("open"); so.setAttribute("aria-hidden", "true");
document.documentElement.style.overflow = "";
if (laatsteTrigger && laatsteTrigger.focus) laatsteTrigger.focus();
}
so.addEventListener("click", function(e){
if (e.target === so || e.target.closest("[data-so-sluit]")) { sluitSo(); return; }
var p = e.target.closest(".ke-rev-pill[data-filter]");

if (p){ zetFilter(p.getAttribute("data-filter")); render(); return; }
if (e.target.closest("[data-so-sort]")){ zetFilter(activeFilter === "helpful" ? "all" : "helpful"); render(); return; }
var duimKnop = e.target.closest("[data-vote]"); if (duimKnop){ opStem(duimKnop); return; }
var trBtn = e.target.closest(".ke-rev-translate");
if (trBtn){ var card = trBtn.closest(".ke-rev-card"), id = card.getAttribute("data-id"), r = null; ALLES.forEach(function(x){ if (x.id === id) r = x; }); if (r) vertaalKaart(card, r); }
});
document.addEventListener("keydown", function(e){ if (e.key === "Escape" && so.classList.contains("open")) sluitSo(); });
sec.addEventListener("click", function(e){
if (e.target.closest("[data-kehr-alle]")) { openSo(e.target, null); return; }
var o = e.target.closest("[data-kehr-open]"); if (o) openSo(o, o.getAttribute("data-kehr-open"));
});

document.addEventListener("click", function(e){ var tr = e.target.closest && e.target.closest("[data-ke-slideout-trigger]"); if (tr && !so.contains(tr)){ e.preventDefault(); openSo(tr, null); } });
document.addEventListener("keydown", function(e){ if (e.key !== "Enter" && e.key !== " ") return; var tr = e.target.closest && e.target.closest("[data-ke-slideout-trigger]"); if (tr && !so.contains(tr)){ e.preventDefault(); openSo(tr, null); } });

function vertaal(r){
var u = PROXY + "?action=translate&country=" + encodeURIComponent(COUNTRY) + "&lang=" + encodeURIComponent(LANG) +
"&to=" + encodeURIComponent(LANG) + "&id=" + encodeURIComponent(r.id);
return fetch(u).then(function(res){ return res.json(); }).then(function(d){
if (!d || !d.ok || !d.comment) return null;
return { id: r.id, rating: r.rating, date: r.date, title: d.title || r.title || "", comment: d.comment, vertaald: true, src: taalVan(r) };
}).catch(function(){ return null; });
}
function toon(){
if (CITATEN.length < MIN_KAARTEN) return;
sec.hidden = false;
startBand();
}
fetch(PROXY + "?country=" + encodeURIComponent(COUNTRY) + "&lang=" + encodeURIComponent(LANG))
.then(function(res){ return res.json(); })
.then(function(d){
var items = (d && d.items) || [];
ALLES = items.slice().sort(function(a, b){ return String(b.date).localeCompare(String(a.date)); });
vulScore(d && d.grade);
var st = sec.querySelector("[data-kehr-scoretekst]");
if (st && !st.textContent.trim() && d && d.grade && d.grade.rating){
st.innerHTML = "<b>" + esc(fmtScore(d.grade.rating)) + "/5</b>" + esc((NA[LANG] || NA.en) + Number(d.grade.count || 0).toLocaleString(LANG) + (EIND[LANG] || EIND.en));
var lz = label(d.grade.rating); if (LANG === "fr") lz = lz.toLowerCase();
var ht = sec.querySelector("[data-kehr-titel]"); if (ht) ht.innerHTML = (VOOR[LANG] || VOOR.en) + lz + (ACHTER[LANG] || ACHTER.en);
var sv = sec.querySelector("[data-kehr-sterren]"); if (sv) sv.setAttribute("data-kehr-sterren", d.grade.rating);
}
var sv2 = sec.querySelector("[data-kehr-sterren]");
if (sv2) sv2.innerHTML = sterren(sv2.getAttribute("data-kehr-sterren"), 16);
fetch(PROXY + "?action=votes&sku=" + encodeURIComponent(STEMSLEUTEL)).then(function(r){ return r.json(); })
.then(function(v){ if (v && v.votes){ votes = v.votes; if (so.classList.contains("open")) render(); } }).catch(function(){});

var keuze = kies(items, LANG, MAX_KAARTEN, MAX_VERTAAL);
CITATEN = keuze.native.map(function(r){ return { id: r.id, rating: r.rating, date: r.date, title: r.title || "", comment: r.comment, vertaald: false }; });
if (CITATEN.length >= MIN_KAARTEN) toon();
if (!keuze.vertaal.length) return;

var nodig = keuze.vertaal.length;
function ronde(lijst, reserve){
Promise.all(lijst.map(vertaal)).then(function(extra){
extra.forEach(function(x){ if (x){ VERTAALD[x.id] = { comment: x.comment, title: x.title }; CITATEN.push(x); nodig--; } });
CITATEN.sort(function(a, b){ return String(b.date).localeCompare(String(a.date)); });
if (so.classList.contains("open")) render();
toon();
if (nodig > 0 && reserve.length) ronde(reserve.slice(0, nodig), reserve.slice(nodig));
});
}
ronde(keuze.vertaal, keuze.rest.slice(0, MAX_RESERVE));
})
.catch(function(){  });
})();
} catch (e) { console.error('KE Reviews band:', e); }
/* overal (11-slideout-overal.liquid) */
if (__KE_C["overal"]) try {
var __ke11 = document.getElementById('ke11-so'); if (__ke11 && __ke11.parentNode !== document.body) document.body.appendChild(__ke11);
(function(){
"use strict";
var so = document.getElementById("ke11-so");
if (!so || so.getAttribute("data-ke11-klaar")) return;
so.setAttribute("data-ke11-klaar", "1");

var PROXY = "https://ke-reviews-proxy.marketing-bff.workers.dev/";
var COUNTRY = (so.getAttribute("data-ke11-country") || "NL").toUpperCase();
var LANG = (so.getAttribute("data-ke11-lang") || "nl").toLowerCase();

var T = {
nl:{ laden:"Laden…", geen:"Geen beoordelingen", title:"Beoordelingen", subSvc:"Beoordelingen over onze service en winkel", tabSvc:"Service & winkel", all:"Alle", none:"Geen reviews met deze filter.", reviews:"beoordelingen", verifiedBuyer:"Geverifieerde koper", translate:"Vertalen", showOriginal:"Toon origineel", translatedFrom:"Vertaald uit het", translating:"Vertalen…", translateFailed:"Vertaling niet beschikbaar", sortHelpful:"Populairst", helpful:"Was dit nuttig?", helpfulYes:"Ja, nuttig", helpfulNo:"Niet nuttig", helpfulUndo:"Stem intrekken", lab:["Matig","Redelijk","Goed","Zeer goed","Uitstekend"] },
en:{ laden:"Loading…", geen:"No reviews", title:"Reviews", subSvc:"Reviews about our service and store", tabSvc:"Service & store", all:"All", none:"No reviews with this filter.", reviews:"reviews", verifiedBuyer:"Verified buyer", translate:"Translate", showOriginal:"Show original", translatedFrom:"Translated from", translating:"Translating…", translateFailed:"Translation unavailable", sortHelpful:"Most liked", helpful:"Was this helpful?", helpfulYes:"Yes, helpful", helpfulNo:"Not helpful", helpfulUndo:"Undo vote", lab:["Poor","Fair","Good","Very Good","Excellent"] },
de:{ laden:"Wird geladen…", geen:"Keine Bewertungen", title:"Bewertungen", subSvc:"Bewertungen über unseren Service und Shop", tabSvc:"Service & Shop", all:"Alle", none:"Keine Bewertungen mit diesem Filter.", reviews:"Bewertungen", verifiedBuyer:"Verifizierter Käufer", translate:"Übersetzen", showOriginal:"Original anzeigen", translatedFrom:"Übersetzt aus dem", translating:"Übersetzung…", translateFailed:"Übersetzung nicht verfügbar", sortHelpful:"Beliebteste", helpful:"War das hilfreich?", helpfulYes:"Ja, hilfreich", helpfulNo:"Nicht hilfreich", helpfulUndo:"Bewertung zurücknehmen", lab:["Mäßig","Befriedigend","Gut","Sehr gut","Ausgezeichnet"] },
fr:{ laden:"Chargement…", geen:"Aucun avis", title:"Avis", subSvc:"Avis sur notre service et notre boutique", tabSvc:"Service & boutique", all:"Tous", none:"Aucun avis avec ce filtre.", reviews:"avis", verifiedBuyer:"Acheteur vérifié", translate:"Traduire", showOriginal:"Voir l'original", translatedFrom:"Traduit du", translating:"Traduction…", translateFailed:"Traduction indisponible", sortHelpful:"Les plus appréciés", helpful:"Cet avis vous a-t-il aidé ?", helpfulYes:"Oui, utile", helpfulNo:"Pas utile", helpfulUndo:"Annuler le vote", lab:["Insuffisant","Satisfaisant","Bon","Très bon","Excellent"] },
es:{ laden:"Cargando…", geen:"Sin opiniones", title:"Reseñas", subSvc:"Reseñas sobre nuestro servicio y tienda", tabSvc:"Servicio y tienda", all:"Todas", none:"No hay reseñas con este filtro.", reviews:"reseñas", verifiedBuyer:"Comprador verificado", translate:"Traducir", showOriginal:"Ver original", translatedFrom:"Traducido del", translating:"Traduciendo…", translateFailed:"Traducción no disponible", sortHelpful:"Más populares", helpful:"¿Te ha resultado útil?", helpfulYes:"Sí, útil", helpfulNo:"No útil", helpfulUndo:"Retirar voto", lab:["Regular","Aceptable","Bueno","Muy bueno","Excelente"] },
it:{ laden:"Caricamento…", geen:"Nessuna recensione", title:"Recensioni", subSvc:"Recensioni sul nostro servizio e negozio", tabSvc:"Servizio e negozio", all:"Tutte", none:"Nessuna recensione con questo filtro.", reviews:"recensioni", verifiedBuyer:"Acquirente verificato", translate:"Traduci", showOriginal:"Mostra originale", translatedFrom:"Tradotto dal", translating:"Traduzione…", translateFailed:"Traduzione non disponibile", sortHelpful:"Più apprezzate", helpful:"È stato utile?", helpfulYes:"Sì, utile", helpfulNo:"Non utile", helpfulUndo:"Annulla voto", lab:["Mediocre","Discreto","Buono","Molto buono","Eccellente"] }
};
var t = T[LANG] || T.en;

var TW = { en:"the and was very with this for that have not are my", de:"und der die das ist nicht mit sehr ich wurde auch wir ein eine was",
nl:"het een niet ik met zeer goed snel werd ook maar van was", fr:"les et très pas est une je livraison des pour",
es:"muy que con los las para pero también", it:"molto che con di non sono anche per della" };
var TWS = {}; for (var k in TW) TWS[k] = " " + TW[k] + " ";
function taal(txt){
var w = String(txt || "").toLowerCase().replace(/[^a-zà-ÿ\s]/g, " ").split(/\s+/), sc = {}, best = null, hi = 0, gelijk = false;
for (var i = 0; i < w.length; i++){ if (!w[i]) continue; for (var l in TWS){ if (TWS[l].indexOf(" " + w[i] + " ") !== -1) sc[l] = (sc[l] || 0) + 1; } }
for (var l2 in sc){ if (sc[l2] > hi){ hi = sc[l2]; best = l2; gelijk = false; } else if (sc[l2] === hi) gelijk = true; }
return hi >= 2 && !gelijk ? best : null;
}
function taalVan(r){ return taal((r.title || "") + " " + (r.comment || "")) || String(r.srcLang || "").toLowerCase().split(/[-_]/)[0]; }

function esc(s){ return String(s == null ? "" : s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }
function ster(pct){ return '<span style="--f:'+pct+'%"><svg aria-hidden="true"><use href="#ke11-star"/></svg><svg class="ke11-sv-f" aria-hidden="true"><use href="#ke11-star"/></svg></span>'; }
function sterren(rating, px, cls){
var r = Math.max(0, Math.min(5, Number(rating) || 0)), out = "";
for (var i = 0; i < 5; i++) out += ster(Math.round(Math.max(0, Math.min(1, r - i)) * 100));
return '<span class="'+(cls ? cls+' ' : '')+'ke11-sv" role="img" aria-label="'+(Math.round(r*100)/100)+' / 5"'+(px ? ' style="font-size:'+px+'px"' : '')+'>'+out+'</span>';
}
function sinds(iso){
if (!iso) return "";
var d = new Date(iso); if (isNaN(d.getTime())) return "";
var diff = Math.round((d.getTime() - Date.now()) / 1000), a = Math.abs(diff), rtf;
try { rtf = new Intl.RelativeTimeFormat(LANG, { numeric: "auto" }); } catch (e) { rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" }); }
if (a < 86400) return rtf.format(Math.round(diff / 3600), "hour");
if (a < 2592000) return rtf.format(Math.round(diff / 86400), "day");
if (a < 31536000) return rtf.format(Math.round(diff / 2592000), "month");
return rtf.format(Math.round(diff / 31536000), "year");
}
function fmtScore(n){ var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < .005 ? String(Math.round(r)) : r.toLocaleString(LANG, { maximumFractionDigits: 2 }); }
function langName(code){ try { return new Intl.DisplayNames([LANG], { type: "language" }).of(code); } catch (e) { return String(code || "").toUpperCase(); } }
var VINK = '<svg width="15" height="15" fill="none" aria-hidden="true"><use href="#ke11-vink"/></svg>';
var SMAL = window.matchMedia("(max-width: 749px)");
var ALLES = [];
var VERTAALD = {};

if (so.parentElement !== document.body) document.body.appendChild(so);
var body = so.querySelector("[data-so-body]"), filters = so.querySelector("[data-so-filters]"), sortPil = so.querySelector("[data-so-sort]");
so.querySelector("[data-so-titel]").textContent = t.title;
so.querySelector("[data-so-sub]").textContent = t.subSvc;
so.querySelector("[data-so-tab]").textContent = t.tabSvc;
so.querySelector('.ke-rev-pill[data-filter="all"]').textContent = t.all;
sortPil.textContent = t.sortHelpful;
var activeFilter = "all", panelSort = "top", laatsteTrigger = null;
function zetFilter(f){ activeFilter = f; panelSort = f === "helpful" ? "helpful" : "top"; filters.querySelectorAll(".ke-rev-pill[data-filter]").forEach(function(q){ q.classList.toggle("active", q.getAttribute("data-filter") === f); }); sortPil.classList.toggle("active", f === "helpful"); }
body.addEventListener("scroll", function(){ body.parentElement.classList.toggle("ke-scrolled", body.scrollTop > 8 && SMAL.matches); }, { passive: true });

var STEMSLEUTEL = "svc-" + COUNTRY.toLowerCase();
var votes = {}, mijnStemmen = {};
try { mijnStemmen = JSON.parse(localStorage.getItem("ke-votes-" + STEMSLEUTEL) || "{}") || {}; } catch (e) {}
function bewaarStemmen(){ try { localStorage.setItem("ke-votes-" + STEMSLEUTEL, JSON.stringify(mijnStemmen)); } catch (e) {} }

function stemToken(){
try {
var tk = localStorage.getItem("ke-rev-voter");
if (!tk){ var a = new Uint8Array(16); (window.crypto || window.msCrypto).getRandomValues(a); tk = ""; for (var i = 0; i < 16; i++) tk += ("0" + a[i].toString(16)).slice(-2); localStorage.setItem("ke-rev-voter", tk); }
return tk;
} catch (e) { return ""; }
}
function stemmenVan(r){ var v = votes[r.id] || {}; return { u: Math.max(0, v.u || 0), d: Math.max(0, v.d || 0) }; }
function duim(neer){ return '<svg class="ke-vote-ico'+(neer ? ' ke-vote-ico--neer' : '')+'" width="15" height="15" aria-hidden="true"><use href="#ke11-duim"/></svg>'; }
function stemUI(r){
var v = stemmenVan(r), mijn = mijnStemmen[r.id];
return '<span class="ke-vote" data-votewrap>'+
'<span class="ke-vote-q">'+esc(t.helpful)+'</span>'+
'<button type="button" class="ke-vote-btn'+(mijn==='up'?' voted':'')+'" data-vote="up" data-id="'+esc(r.id)+'" aria-pressed="'+(mijn==='up')+'" title="'+esc(mijn==='up'?t.helpfulUndo:t.helpfulYes)+'" aria-label="'+esc(t.helpfulYes)+'">'+duim(false)+'<span data-up>'+v.u+'</span></button>'+
'<button type="button" class="ke-vote-btn'+(mijn==='down'?' voted':'')+'" data-vote="down" data-id="'+esc(r.id)+'" aria-pressed="'+(mijn==='down')+'" title="'+esc(mijn==='down'?t.helpfulUndo:t.helpfulNo)+'" aria-label="'+esc(t.helpfulNo)+'">'+duim(true)+'<span data-down>'+v.d+'</span></button>'+
'</span>';
}
function stemVerschil(van, naar){
if (van === naar) return null;
var du = 0, dd = 0;
if (van === "up") du--; else if (van === "down") dd--;
if (naar === "up") du++; else if (naar === "down") dd++;
return { du: du, dd: dd };
}
function opStem(knop){
var id = knop.getAttribute("data-id"), richting = knop.getAttribute("data-vote"), wrap = knop.closest("[data-votewrap]");
var vorige = mijnStemmen[id] || "none", nieuw = vorige === richting ? "none" : richting, v = stemVerschil(vorige, nieuw);
if (!v) return;
var opUp = wrap.querySelector("[data-up]"), opDown = wrap.querySelector("[data-down]");
var wasU = parseInt(opUp.textContent, 10) || 0, wasD = parseInt(opDown.textContent, 10) || 0;
function toon(u, d, actief){
opUp.textContent = Math.max(0, u); opDown.textContent = Math.max(0, d);
var kn = wrap.querySelectorAll(".ke-vote-btn");
kn[0].classList.toggle("voted", actief === "up"); kn[1].classList.toggle("voted", actief === "down");
kn[0].setAttribute("aria-pressed", actief === "up"); kn[1].setAttribute("aria-pressed", actief === "down");
}
toon(wasU + v.du, wasD + v.dd, nieuw === "none" ? null : nieuw);
if (nieuw === "none") delete mijnStemmen[id]; else mijnStemmen[id] = nieuw;
bewaarStemmen();
fetch(PROXY + "?action=vote&id=" + encodeURIComponent(id) + "&sku=" + encodeURIComponent(STEMSLEUTEL) + "&voter=" + encodeURIComponent(stemToken()) + "&from=" + vorige + "&to=" + nieuw, { method: "POST" })
.then(function(res){ return res.json(); })
.then(function(d){
if (!d || !d.ok) throw new Error("mislukt");
var stand = d.naar || nieuw;
if (stand === "none") delete mijnStemmen[id]; else mijnStemmen[id] = stand; bewaarStemmen();
if (d.votes){ votes[id] = d.votes; toon(d.votes.u || 0, d.votes.d || 0, stand === "none" ? null : stand); }
})
.catch(function(){ toon(wasU, wasD, vorige === "none" ? null : vorige); if (vorige === "none") delete mijnStemmen[id]; else mijnStemmen[id] = vorige; bewaarStemmen(); });
}

function label(g){ return t.lab[Math.max(1, Math.min(5, Math.round(Number(g) || 0))) - 1]; }
function vulScore(g){
var el = so.querySelector("[data-so-score]");
if (!g || !g.rating){ el.style.display = "none"; return; }
so.querySelector("[data-so-num]").textContent = fmtScore(g.rating);
so.querySelector("[data-so-sterren]").innerHTML = sterren(g.rating, 0, "ke-rev-stars");
so.querySelector("[data-so-scoresub]").textContent = label(g.rating) + (g.count ? " · " + Number(g.count).toLocaleString(LANG) + " " + t.reviews : "");
el.style.display = "";
}
function render(){
var items = ALLES.slice();
if (activeFilter !== "all" && activeFilter !== "helpful"){ var f = parseInt(activeFilter, 10); items = items.filter(function(r){ return Math.round(r.rating) === f; }); }
if (!items.length){ body.innerHTML = '<p class="ke-rev-status">'+esc(t.none)+'</p>'; return; }
if (panelSort === "helpful"){
items.sort(function(a, b){ var va = stemmenVan(a), vb = stemmenVan(b); return (vb.u - vb.d) - (va.u - va.d) || String(b.date).localeCompare(String(a.date)); });
}

var hoog = function(r){ return Math.round(r.rating) >= 4; };
items = (activeFilter === "all" ? [items.filter(hoog), items.filter(function(r){ return !hoog(r); })] : [items]).reduce(function(u, g){ return u.concat(g.filter(function(r){ return taalVan(r) === LANG; }), g.filter(function(r){ return taalVan(r) !== LANG; })); }, []);
body.innerHTML = items.map(function(r){
var src = taalVan(r), canTr = !!r.comment && src !== LANG, tr = VERTAALD[r.id], showing = tr ? "trans" : "orig";
return '<div class="ke-rev-card" data-id="'+esc(r.id)+'" data-showing="'+showing+'">'+
'<div class="ke-rev-card-top"><span>'+sterren(r.rating, 0, "ke-rev-stars")+'</span><span class="ke-rev-verified">'+VINK+esc(t.verifiedBuyer)+'</span></div>'+
(r.title ? '<div class="ke-rev-card-title">'+esc(tr ? (tr.title || r.title) : r.title)+'</div>' : '')+
'<div class="ke-rev-comment">'+esc(tr ? tr.comment : r.comment)+'</div>'+
'<div class="ke-rev-meta">'+esc(sinds(r.date))+'</div>'+
'<div class="ke-rev-foot">'+
(canTr ? '<span class="ke-rev-tr"><button type="button" class="ke-rev-translate">'+esc(tr ? t.showOriginal : t.translate)+'</button><span class="ke-rev-tr-note">'+(tr ? esc(t.translatedFrom+" "+langName(src)) : "")+'</span></span>' : '')+
stemUI(r)+
'</div></div>';
}).join("");
}
function vertaalKaart(card, r){
var c = card.querySelector(".ke-rev-comment"), ti = card.querySelector(".ke-rev-card-title"), note = card.querySelector(".ke-rev-tr-note"), btn = card.querySelector(".ke-rev-translate");
if (card.getAttribute("data-showing") === "trans"){
c.textContent = r.comment; if (ti) ti.textContent = r.title; note.textContent = ""; btn.textContent = t.translate; card.setAttribute("data-showing", "orig"); return;
}
function zet(tr){ c.textContent = tr.comment; if (ti && tr.title) ti.textContent = tr.title; note.textContent = t.translatedFrom + " " + langName(taalVan(r)); btn.textContent = t.showOriginal; card.setAttribute("data-showing", "trans"); }
if (VERTAALD[r.id]){ zet(VERTAALD[r.id]); return; }
btn.textContent = t.translating; btn.disabled = true;
vertaal(r).then(function(x){
btn.disabled = false;
if (!x){ btn.textContent = t.translate; note.textContent = t.translateFailed; return; }
VERTAALD[r.id] = { comment: x.comment, title: x.title }; zet(VERTAALD[r.id]);
});
}

var geladen = false, klaar = false;
function laad(){
if (geladen) return;
geladen = true;
fetch(PROXY + "?country=" + encodeURIComponent(COUNTRY) + "&lang=" + encodeURIComponent(LANG))
.then(function(res){ return res.json(); })
.then(function(d){
var items = (d && d.items) || [];
ALLES = items.slice().sort(function(a, b){ return String(b.date).localeCompare(String(a.date)); });
vulScore(d && d.grade);
klaar = true;
if (so.classList.contains("open")) render();
fetch(PROXY + "?action=votes&sku=" + encodeURIComponent(STEMSLEUTEL)).then(function(r){ return r.json(); })
.then(function(v){ if (v && v.votes){ votes = v.votes; if (so.classList.contains("open")) render(); } }).catch(function(){});
})
.catch(function(){ geladen = false; klaar = true; if (so.classList.contains("open")) body.innerHTML = '<p class="ke-rev-status">'+esc(t.geen)+'</p>'; });
}
function openSo(trigger){
laatsteTrigger = trigger || null;
laad();
if (klaar){ if (!body.children.length) render(); } else body.innerHTML = '<p class="ke-rev-status">'+esc(t.laden)+'</p>';
so.classList.add("open"); so.setAttribute("aria-hidden", "false");
document.documentElement.style.overflow = "hidden";
body.scrollTop = 0;
so.querySelector(".ke-rev-close").focus();
}
function sluitSo(){
so.classList.remove("open"); so.setAttribute("aria-hidden", "true");
document.documentElement.style.overflow = "";
if (laatsteTrigger && laatsteTrigger.focus) laatsteTrigger.focus();
}
so.addEventListener("click", function(e){
if (e.target === so || e.target.closest("[data-so-sluit]")) { sluitSo(); return; }
var p = e.target.closest(".ke-rev-pill[data-filter]");

if (p){ zetFilter(p.getAttribute("data-filter")); render(); return; }
if (e.target.closest("[data-so-sort]")){ zetFilter(activeFilter === "helpful" ? "all" : "helpful"); render(); return; }
var duimKnop = e.target.closest("[data-vote]"); if (duimKnop){ opStem(duimKnop); return; }
var trBtn = e.target.closest(".ke-rev-translate");
if (trBtn){ var card = trBtn.closest(".ke-rev-card"), id = card.getAttribute("data-id"), r = null; ALLES.forEach(function(x){ if (x.id === id) r = x; }); if (r) vertaalKaart(card, r); }
});

function andere(){ return document.getElementById("ke-rev-overlay") || document.getElementById("kehr-so"); }
function opruim(){ if (andere() && so.parentNode) so.parentNode.removeChild(so); }
document.addEventListener("DOMContentLoaded", opruim);
if (document.readyState !== "loading") opruim();
function trigger(e){
var tr = e.target.closest && e.target.closest("[data-ke-slideout-trigger]");
return (tr && !so.contains(tr) && !andere()) ? tr : null;
}
document.addEventListener("click", function(e){ var tr = trigger(e); if (tr){ e.preventDefault(); openSo(tr); } });
document.addEventListener("keydown", function(e){
if (e.key === "Escape"){ if (so.classList.contains("open")) sluitSo(); return; }
if (e.key !== "Enter" && e.key !== " ") return;
var tr = trigger(e); if (tr){ e.preventDefault(); openSo(tr); }
});

function vertaal(r){
var u = PROXY + "?action=translate&country=" + encodeURIComponent(COUNTRY) + "&lang=" + encodeURIComponent(LANG) +
"&to=" + encodeURIComponent(LANG) + "&id=" + encodeURIComponent(r.id);
return fetch(u).then(function(res){ return res.json(); }).then(function(d){
if (!d || !d.ok || !d.comment) return null;
return { id: r.id, rating: r.rating, date: r.date, title: d.title || r.title || "", comment: d.comment, vertaald: true, src: taalVan(r) };
}).catch(function(){ return null; });
}
})();
} catch (e) { console.error('KE Reviews overal:', e); }
}
